import type {
  AccountLinkPreview,
  AccountLinkPurpose,
  DeliveryDocument,
  BelowFloorEntry,
  BoxSummary,
  CourierEarnings,
  SettlementGroup,
  ForwardDemandView,
  ActiveBatchRow,
  AssignUserLocationPayload,
  BalanceFilters,
  BouquetBuilderItem,
  BouquetBuildSummary,
  BouquetTemplate,
  CatalogItem,
  CatalogListItem,
  ConsumablePreset,
  ConsumableRollSummary,
  FrontRollRow,
  PaperRollRow,
  ActiveConsumableRollResponse,
  CreateBouquetBuildPayload,
  CreateBouquetCompletePayload,
  CreateBouquetTemplatePayload,
  CreateItemPayload,
  CreateItemCategoryPayload,
  Color,
  UpdateItemPayload,
  UpdateReceivedBatchPayload,
  CreateLocationPayload,
  CreateZonePayload,
  CreateSalePayload,
  RingUpOrderPayload,
  CreateSupplierPayload,
  InventoryBalance,
  ItemCategory,
  ItemYieldResponse,
  Location,
  Zone,
  LoginResponse,
  LogWastePayload,
  MeResponse,
  ReceiveFlowerBatchPayload,
  ReceiveStockPayload,
  ReceivedBatchMoney,
  AdjustStockPayload,
  AdjustStockResponse,
  RefreshResponse,
  ReceivedBatchHistoryListResponse,
  ReceivedBatchHistoryRow,
  Sale,
  SalePeriodTotals,
  PeriodSaleRefund,
  SaleRefundPreview,
  SaleRefundRow,
  SaleRefundLinePayload,
  RefundStockQuestion,
  RefundStockToCheck,
  CreateSaleRefundPayload,
  SessionUser,
  Shift,
  MyWorkDayEarnings,
  Task,
  TaskSchedule,
  AssignableUser,
  BulkCreateShiftsPayload,
  BulkCreateShiftsResponse,
  CreateShiftPayload,
  ListMySalesQuery,
  ListMyShiftsQuery,
  ListShiftsQuery,
  ListTasksQuery,
  UpdateShiftPayload,
  UpdateTaskPayload,
  UpdateTaskSchedulePayload,
  ScheduledDelivery,
  CreateScheduledDeliveryPayload,
  UpdateScheduledDeliveryPayload,
  ConfirmDeliveryLinePayload,
  ListDeliveriesQuery,
  BlogPostSummary,
  BlogPostDetail,
  CreateBlogPostPayload,
  CreatePayrollAdjustmentPayload,
  CreatePayrollPaymentPayload,
  PayrollAdjustmentRecord,
  PayrollAdjustmentsResponse,
  PayrollPaidMonth,
  PayDayDue,
  PayrollPaymentRecord,
  PayrollSummaryResponse,
  SubCategory,
  Supplier,
  TransferStockPayload,
  ShopifyPickupOptions,
  TransferBetweenLocationsPayload,
  UpdateLocationPayload,
  UpdateBouquetTemplatePayload,
  UpdateSupplierPayload,
  CreateUserPayload,
  UserAssignmentRecord,
  UserActivityEntry,
  AppLanguage,
  UpdateMyContactPayload,
  UpdateUserContactPayload,
  UpdateUserCompensationPayload,
  UpdateUserPayTermsPayload,
  UserListEntry,
  YieldRow,
  InvoiceDetail,
  InvoicePreviewDetail,
  ListPapersQuery,
  PaperList,
  InvoiceCoverage,
  PaperCredits,
  WaitingForFacturaList,
  PatchInvoiceLinePayload,
  CommitInvoicePayload,
  AppTicketListItem,
  BugReportListItem,
  AppTicketDetail,
  CreateTicketPayload,
  PatchTicketPayload,
  TicketComment,
  CaptureDeliveryLineBarcodePayload,
  CatalogDraft,
  CatalogDraftGroup,
  AutoCreatedItemRow,
  CatalogDraftWorkspace,
  FinalizeManyDraftsPayload,
  FinalizeManyDraftsResult,
  UpdateDraftPayload,
  CreateDraftGroupPayload,
  UpdateDraftGroupPayload,
  ShopifyCredentialStatus,
  TelegramPeople,
  TelegramStatus,
  TelegramTestResult,
  SetShopifyCredentialPayload,
  ShopifyVariant,
  ShopifyLinkFilter,
  ShopifyCatalogRefreshResult,
  ShopifyBarcodeMatches,
  CreateShopifyLinkPayload,
  ShopifyLinkResult,
  ShopifyOrderView,
  ShopifyShopFit,
  ShopifyOrderSkipReason,
  WebOrderAttentionCounts,
  WebOrderJourney,
  WebOrderRow,
  WebOrdersPersonReport,
  WebOrdersReport,
  WebOrdersReportQuery,
  CustomerOrder,
  OrdersCalendarEntry,
  CreateCustomerOrderPayload,
  UpdateCustomerOrderPayload,
  DeliveryProblem,
  ListCustomerOrdersQuery,
  OrderReferencePhoto,
  AiControlSystem,
  AiEditableSystemKey,
  AiInstructionVersions,
  AiPhotoSearchTrial,
  AiTestablePastSearch,
  AuthAuditLogEntry,
  ListAuthAuditLogQuery,
  CatalogAuditEntry,
  CatalogUndoManyResult,
  ListCatalogAuditLogQuery,
  CommissionRuleView,
  OrderSource,
  StaffOrderPaymentMethod,
  RecordOrderPaymentPayload,
  BouquetBuildDetail,
  BouquetBuildPhotoEntry,
  CustomerOrderEventView,
  ListShopAuditLogQuery,
  ShopAuditLogEntry,
  DeliveryJob,
  DeliveryListTotals,
  DeliveryJobEvent,
  CourierActionResult,
  CourierOverviewRow,
  CourierPayoutRuleView,
  CourierShift,
  DeliveryJobDetail,
  AppNotification,
  AssignableCourier,
  AssignmentPreview,
  PreviewDeliveryPayoutPayload,
  CreateDeliveryJobPayload,
  ListDeliveryJobsQuery,
  PayoutRule,
  CreatePayoutRulePayload,
  VacationRequest,
  VacationRequestStatus,
  CreateVacationRequestPayload,
  ReorderSuggestion,
  AnalyticsHomeSummary,
  AnalyticsSalesSummary,
  AnalyticsSpendSummary,
  AnalyticsWasteSummary,
  AnalyticsStockValue,
  SupplierRankingRow,
  SupplierBatchQualityRow,
  ItemPriceHistory,
  OrderableItem,
  UpdateDeliveryJobPayload,
  // G-32 recurring costs + G-39 one-time expenses (one contiguous block).
  OperatingCostsSummary,
  RecurringCostRecord,
  RecurringCostListResponse,
  CreateRecurringCostPayload,
  UpdateRecurringCostPayload,
  OneTimeExpenseRecord,
  OneTimeExpenseListResponse,
  OneTimeExpenseCategory,
  CreateOneTimeExpensePayload,
  UpdateOneTimeExpensePayload,
  StoredReceiptTemplate,
  HandTypedNearby,
  InvoicePaymentsView,
  PaperUse,
  PurchasesIvaSummary,
  RecordInvoicePaymentPayload,
  SalesIvaSummary,
  HaciendaBalance,
} from "./types";

import {
  acquireItemImageBlobUrl,
  itemImageQuery,
  releaseItemImageBlobUrl as releaseCachedItemImageBlobUrl,
  type ItemImageBlobSize,
  type ItemImageVariant,
} from "../utils/itemImageBlobCache";
// G-72: breadcrumbs for bug reports. Records method, path and status only —
// never the response body, which carries customer details on order endpoints.
import { noteApiFailure } from "../platform/consoleBuffer";

// The API base may be RELATIVE in production ("/api/v1": Caddy serves the SPA
// and the API from one origin) and absolute in development. Every request
// builds `new URL(...)` from it, which throws on a relative string — the
// first production login failed with "Invalid URL" (2026-09-09). Resolve it
// against the page origin once, here; an absolute value is unchanged.
const BASE_URL = new URL(
  import.meta.env.VITE_API_BASE_URL ?? "http://localhost:3000/v1",
  window.location.origin,
)
  .toString()
  .replace(/\/$/, "");
const SESSION_HARD_CAP_MS = 8 * 60 * 60 * 1000;
const SESSION_START_KEY = "flowershop_session_start";

/** sessionStorage key for the tablet's ShopFloorSession credential. */
export const SFS_KEY = "shopFloorSessionId";

function persistSessionStart(ms: number) {
  try {
    sessionStorage.setItem(SESSION_START_KEY, String(ms));
  } catch {
    /* private mode / quota */
  }
}

function loadSessionStartFromStorage(): number | null {
  try {
    const raw = sessionStorage.getItem(SESSION_START_KEY);
    if (!raw) return null;
    const n = Number(raw);
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}

function clearPersistedSessionStart() {
  try {
    sessionStorage.removeItem(SESSION_START_KEY);
  } catch {
    /* */
  }
}

interface InternalState {
  accessToken: string | null;
  loginAtMs: number | null;
  forceLogout: () => void;
  isRefreshing: Promise<boolean> | null;
  /** In-memory JWT₃ for the current floor worker (never persisted). */
  floorToken: string | null;
  /** Registered by ShopModeProvider — navigates to /app/in-the-shop instead of /login
   *  when the CRM refresh fails while a shop floor session is present. */
  navigateToShopMode: (() => void) | null;
}

const state: InternalState = {
  accessToken: null,
  loginAtMs: null,
  forceLogout: () => {
    state.accessToken = null;
    state.loginAtMs = null;
  },
  isRefreshing: null,
  floorToken: null,
  navigateToShopMode: null,
};

export function configureAuth(options: { forceLogout: () => void }) {
  state.forceLogout = () => {
    state.accessToken = null;
    state.loginAtMs = null;
    clearPersistedSessionStart();
    options.forceLogout();
  };
}

export function setSession(token: string, loginAtMs: number) {
  state.accessToken = token;
  state.loginAtMs = loginAtMs;
  persistSessionStart(loginAtMs);
}

export function getAccessToken(): string | null {
  return state.accessToken;
}

export function getLoginAt(): number | null {
  return state.loginAtMs;
}

function getCsrfToken(): string | null {
  const match = document.cookie
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith("csrf_token="));
  if (!match) return null;
  return decodeURIComponent(match.slice("csrf_token=".length));
}

interface ApiError extends Error {
  status: number;
  body: unknown;
}

function buildError(status: number, body: unknown): ApiError {
  const messageFromBody = (() => {
    if (body && typeof body === "object" && "message" in body) {
      const m = (body as { message: unknown }).message;
      if (typeof m === "string") return m;
      if (Array.isArray(m)) return m.join(", ");
    }
    return `Request failed with ${status}`;
  })();
  const error = new Error(messageFromBody) as ApiError;
  error.status = status;
  error.body = body;
  return error;
}

interface RequestOptions {
  method?: "GET" | "POST" | "PUT" | "PATCH" | "DELETE";
  body?: unknown;
  query?: Record<string, string | undefined>;
  withCredentials?: boolean;
  skipAuth?: boolean;
  retry?: boolean;
  /** Attach the explicit ShopModeProvider credential as X-Shop-Floor-Session-Id. */
  includeSfs?: boolean;
  /** Explicit armed-session credential owned by ShopModeProvider. */
  shopFloorSessionId?: string;
}

async function rawRequest<T>(path: string, opts: RequestOptions): Promise<T> {
  const url = new URL(`${BASE_URL}${path}`);
  if (opts.query) {
    for (const [key, value] of Object.entries(opts.query)) {
      if (value !== undefined && value !== "") {
        url.searchParams.append(key, value);
      }
    }
  }

  const headers: Record<string, string> = {
    Accept: "application/json",
  };
  if (opts.body !== undefined) {
    headers["Content-Type"] = "application/json";
  }
  if (!opts.skipAuth && state.accessToken) {
    headers["Authorization"] = `Bearer ${state.accessToken}`;
  }
  if (opts.withCredentials) {
    const csrf = getCsrfToken();
    if (csrf) {
      headers["X-CSRF-Token"] = csrf;
    }
  }
  if (opts.includeSfs) {
    if (opts.shopFloorSessionId) {
      headers["X-Shop-Floor-Session-Id"] = opts.shopFloorSessionId;
    }
  }

  const response = await fetch(url.toString(), {
    method: opts.method ?? "GET",
    headers,
    body: opts.body !== undefined ? JSON.stringify(opts.body) : undefined,
    credentials: opts.withCredentials ? "include" : "omit",
  });

  if (response.status === 204) {
    return undefined as T;
  }

  const text = await response.text();
  const parsed = text ? safeJsonParse(text) : null;

  if (!response.ok) {
    noteApiFailure(opts.method ?? "GET", path, response.status);
    throw buildError(response.status, parsed);
  }

  return parsed as T;
}

function safeJsonParse(input: string): unknown {
  try {
    return JSON.parse(input);
  } catch {
    return input;
  }
}

async function refreshAccessToken(): Promise<boolean> {
  const capStart = state.loginAtMs ?? loadSessionStartFromStorage();
  if (capStart !== null && Date.now() - capStart >= SESSION_HARD_CAP_MS) {
    return false;
  }
  if (state.isRefreshing) {
    return state.isRefreshing;
  }
  state.isRefreshing = (async () => {
    try {
      const result = await rawRequest<RefreshResponse>("/auth/refresh", {
        method: "POST",
        withCredentials: true,
        skipAuth: true,
      });
      state.accessToken = result.accessToken;
      if (state.loginAtMs === null) {
        const persisted = loadSessionStartFromStorage();
        state.loginAtMs = persisted ?? Date.now();
        if (persisted === null) {
          persistSessionStart(state.loginAtMs);
        }
      }
      return true;
    } catch {
      return false;
    } finally {
      state.isRefreshing = null;
    }
  })();
  return state.isRefreshing;
}

async function runRestoreSession(): Promise<SessionUser | null> {
  const persistedStart = loadSessionStartFromStorage();
  if (persistedStart !== null && Date.now() - persistedStart >= SESSION_HARD_CAP_MS) {
    clearPersistedSessionStart();
    return null;
  }

  try {
    const result = await rawRequest<RefreshResponse>("/auth/refresh", {
      method: "POST",
      withCredentials: true,
      skipAuth: true,
    });
    state.accessToken = result.accessToken;
    state.loginAtMs = persistedStart ?? Date.now();
    if (persistedStart === null) {
      persistSessionStart(state.loginAtMs);
    }
  } catch {
    return null;
  }

  try {
    const me = await rawRequest<MeResponse>("/auth/me", {});
    if (!me.isActive) {
      state.accessToken = null;
      state.loginAtMs = null;
      clearPersistedSessionStart();
      return null;
    }
    return {
      id: me.id,
      email: me.email,
      fullName: me.fullName,
      role: me.role,
      assignedLocation: me.assignedLocation ?? null,
      payVisible: me.payVisible === true,
      emailVerified: me.emailVerified,
    };
  } catch {
    state.accessToken = null;
    state.loginAtMs = null;
    clearPersistedSessionStart();
    return null;
  }
}

/** In-flight dedupe so React Strict Mode / double effects do not rotate the refresh cookie twice. */
let restoreSessionPromise: Promise<SessionUser | null> | null = null;

/**
 * On full page load: exchange httpOnly refresh cookie for access token and load user.
 * Requires CSRF cookie + refresh cookie (same as login).
 */
export function restoreSession(): Promise<SessionUser | null> {
  if (!restoreSessionPromise) {
    restoreSessionPromise = runRestoreSession().finally(() => {
      restoreSessionPromise = null;
    });
  }
  return restoreSessionPromise;
}

export async function request<T>(path: string, opts: RequestOptions = {}): Promise<T> {
  try {
    return await rawRequest<T>(path, opts);
  } catch (error) {
    const isUnauth =
      error instanceof Error && (error as ApiError).status === 401 && !opts.skipAuth && !opts.retry;
    if (!isUnauth) throw error;

    const refreshed = await refreshAccessToken();
    if (!refreshed) {
      // If the Manager's CRM session expired while a shop floor session is active,
      // keep the tablet in floor mode instead of redirecting to /login.
      // The SFS is a separate credential — it outlives the CRM JWT.
      let hasSfs = false;
      try { hasSfs = Boolean(sessionStorage.getItem(SFS_KEY)); } catch { /* */ }
      if (hasSfs) {
        state.accessToken = null;
        state.loginAtMs = null;
        state.navigateToShopMode?.();
        throw error;
      }
      state.forceLogout();
      throw error;
    }
    return rawRequest<T>(path, { ...opts, retry: true });
  }
}

interface FormRequestOptions {
  method?: "POST" | "PATCH";
}

async function rawFormRequest<T>(
  path: string,
  form: FormData,
  opts?: FormRequestOptions,
): Promise<T> {
  const url = new URL(`${BASE_URL}${path}`);
  const headers: Record<string, string> = {
    Accept: "application/json",
  };
  if (!state.accessToken) {
    throw buildError(401, { message: "Not authenticated" });
  }
  headers["Authorization"] = `Bearer ${state.accessToken}`;

  const response = await fetch(url.toString(), {
    method: opts?.method ?? "POST",
    headers,
    body: form,
    credentials: "omit",
  });

  const text = await response.text();
  const parsed = text ? safeJsonParse(text) : null;

  if (!response.ok) {
    noteApiFailure(opts?.method ?? "POST", path, response.status);
    throw buildError(response.status, parsed);
  }

  return parsed as T;
}

async function formRequest<T>(
  path: string,
  form: FormData,
  opts?: FormRequestOptions,
): Promise<T> {
  try {
    return await rawFormRequest<T>(path, form, opts);
  } catch (error) {
    const isUnauth =
      error instanceof Error && (error as ApiError).status === 401;
    if (!isUnauth) throw error;
    const refreshed = await refreshAccessToken();
    if (!refreshed) {
      state.forceLogout();
      throw error;
    }
    return rawFormRequest<T>(path, form, opts);
  }
}

async function fetchAuthorizedBlob(path: string): Promise<Blob> {
  async function attempt(): Promise<Response> {
    const url = new URL(`${BASE_URL}${path}`);
    if (!state.accessToken) {
      throw buildError(401, { message: "Not authenticated" });
    }
    return fetch(url.toString(), {
      method: "GET",
      headers: {
        Authorization: `Bearer ${state.accessToken}`,
        Accept: "application/pdf,*/*",
      },
      credentials: "omit",
    });
  }

  let response = await attempt();
  if (response.status === 401) {
    const refreshed = await refreshAccessToken();
    if (!refreshed) {
      state.forceLogout();
      throw buildError(401, { message: "Not authenticated" });
    }
    response = await attempt();
  }

  if (!response.ok) {
    const text = await response.text();
    let parsed: unknown = text || null;
    if (text) {
      try {
        parsed = JSON.parse(text);
      } catch {
        parsed = { message: text };
      }
    }
    noteApiFailure("POST", path, response.status);
    throw buildError(response.status, parsed);
  }

  return response.blob();
}

/**
 * Auth-gated file → object URL, or null when the server has nothing (404) or
 * refuses. Goes through `fetchAuthorizedBlob`, so an expired 15-minute access
 * token is refreshed and retried like every other request — a bare `fetch`
 * here used to return null on the 401 and the caller read that as "no file"
 * (pre-release fix 2026-09-09: the receipt viewer went dead after 15 idle
 * minutes; the two image loaders had the same shape).
 */
async function fetchBlobUrlOrNull(path: string): Promise<string | null> {
  try {
    const blob = await fetchAuthorizedBlob(path);
    return URL.createObjectURL(blob);
  } catch {
    return null;
  }
}

async function rawFetchItemImageBlobUrl(
  itemId: string,
  options?: ItemImageVariant,
): Promise<string | null> {
  return fetchBlobUrlOrNull(
    `/items/${encodeURIComponent(itemId)}/image${itemImageQuery(options)}`,
  );
}

export const api = {
  async login(email: string, password: string): Promise<LoginResponse> {
    const result = await rawRequest<LoginResponse>("/auth/login", {
      method: "POST",
      body: { email, password },
      withCredentials: true,
      skipAuth: true,
    });
    setSession(result.accessToken, Date.now());
    return result;
  },

  async me(): Promise<MeResponse> {
    return request<MeResponse>("/auth/me");
  },

  /*
   * G-136 — the emailed-link doors. Nobody holding a link is signed in, so
   * these go through `rawRequest` with no token and no refresh-on-401: a dead
   * link must never bounce the page to the sign-in screen. The secret is sent
   * in the body; the page took it from the URL fragment.
   */
  previewAccountLink(token: string): Promise<AccountLinkPreview> {
    return rawRequest<AccountLinkPreview>("/account/link/preview", {
      method: "POST",
      body: { token },
      skipAuth: true,
    });
  },

  completeAccountSetup(token: string, password: string): Promise<{ email: string }> {
    return rawRequest<{ email: string }>("/account/setup", {
      method: "POST",
      body: { token, password },
      skipAuth: true,
    });
  },

  requestPasswordReset(email: string): Promise<{ ok: true }> {
    return rawRequest<{ ok: true }>("/account/forgot-password", {
      method: "POST",
      body: { email },
      skipAuth: true,
    });
  },

  completePasswordReset(token: string, password: string): Promise<void> {
    return rawRequest<void>("/account/reset-password", {
      method: "POST",
      body: { token, password },
      skipAuth: true,
    });
  },

  confirmAccountEmail(token: string): Promise<{ purpose: AccountLinkPurpose }> {
    return rawRequest<{ purpose: AccountLinkPurpose }>("/account/confirm-email", {
      method: "POST",
      body: { token },
      skipAuth: true,
    });
  },

  /** G-136: a verify link to my own address. */
  sendMyVerificationEmail(): Promise<void> {
    return request<void>("/account/verify-email", { method: "POST" });
  },

  /** G-136: my new sign-in address; it applies once that address confirms. */
  requestMyEmailChange(newEmail: string, currentPassword: string): Promise<{ pendingEmail: string }> {
    return request<{ pendingEmail: string }>("/account/email-change", {
      method: "POST",
      body: { newEmail, currentPassword },
    });
  },

  async changePassword(payload: {
    currentPassword: string;
    newPassword: string;
  }): Promise<void> {
    await request<void>("/auth/change-password", {
      method: "POST",
      body: payload,
      withCredentials: true,
    });
  },

  async logout(): Promise<void> {
    try {
      await rawRequest<void>("/auth/logout", {
        method: "POST",
        withCredentials: true,
      });
    } catch {
      // Logout must always succeed locally; ignore network errors.
    } finally {
      state.forceLogout();
    }
  },

  listLocations(options?: { includeInactive?: boolean }): Promise<Location[]> {
    const q =
      options?.includeInactive === true ? "?includeInactive=true" : "";
    return request<Location[]>(`/locations${q}`);
  },

  getLocation(id: string): Promise<Location> {
    return request<Location>(`/locations/${encodeURIComponent(id)}`);
  },

  updateLocation(id: string, payload: UpdateLocationPayload): Promise<Location> {
    return request<Location>(`/locations/${encodeURIComponent(id)}`, {
      method: "PATCH",
      body: payload,
    });
  },

  createZone(
    locationId: string,
    payload: CreateZonePayload,
  ): Promise<Zone> {
    return request<Zone>(
      `/locations/${encodeURIComponent(locationId)}/zones`,
      { method: "POST", body: payload },
    );
  },

  updateZone(zoneId: string, payload: { isActive: boolean }): Promise<Zone> {
    return request<Zone>(
      `/locations/zones/${encodeURIComponent(zoneId)}`,
      { method: "PATCH", body: payload },
    );
  },

  /**
   * G-64 — one shop's receipt design. `blocks` comes back NULL when the shop
   * has never opened the builder, which means "the default template": the
   * renderer owns that default, so the server never restates it.
   */
  getReceiptTemplate(locationId: string): Promise<StoredReceiptTemplate> {
    return request<StoredReceiptTemplate>(
      `/receipt-templates/${encodeURIComponent(locationId)}`,
    );
  },

  saveReceiptTemplate(
    locationId: string,
    payload: { blocks: unknown[]; logoScale: number },
  ): Promise<StoredReceiptTemplate> {
    return request<StoredReceiptTemplate>(
      `/receipt-templates/${encodeURIComponent(locationId)}`,
      { method: "PATCH", body: payload },
    );
  },

  uploadReceiptLogo(
    locationId: string,
    file: File,
  ): Promise<StoredReceiptTemplate> {
    const fd = new FormData();
    fd.append("file", file, file.name);
    return formRequest<StoredReceiptTemplate>(
      `/receipt-templates/${encodeURIComponent(locationId)}/logo`,
      fd,
    );
  },

  clearReceiptLogo(locationId: string): Promise<StoredReceiptTemplate> {
    return request<StoredReceiptTemplate>(
      `/receipt-templates/${encodeURIComponent(locationId)}/logo`,
      { method: "DELETE" },
    );
  },

  /** Object URL for the shop's logo, or null when there is none. */
  fetchReceiptLogoUrl(locationId: string): Promise<string | null> {
    return fetchBlobUrlOrNull(
      `/receipt-templates/${encodeURIComponent(locationId)}/logo`,
    );
  },

  listCategories(): Promise<ItemCategory[]> {
    return request<ItemCategory[]>("/item-categories");
  },

  createCategory(payload: CreateItemCategoryPayload): Promise<ItemCategory> {
    return request<ItemCategory>("/item-categories", { method: "POST", body: payload });
  },

  /** G-30: owner-only VAT rate edit; never touches historical sale snapshots. */
  updateCategoryVatRate(id: string, vatRatePercent: number): Promise<ItemCategory> {
    return request<ItemCategory>(
      `/item-categories/${encodeURIComponent(id)}/vat-rate`,
      { method: "PATCH", body: { vatRatePercent } },
    );
  },

  /** G-45: owner-only target-margin edit, sibling of the VAT rate above. */
  updateCategoryTargetMargin(
    id: string,
    targetMarginPercent: number,
  ): Promise<ItemCategory> {
    return request<ItemCategory>(
      `/item-categories/${encodeURIComponent(id)}/target-margin`,
      { method: "PATCH", body: { targetMarginPercent } },
    );
  },

  listColors(): Promise<Color[]> {
    return request<Color[]>("/item-colors");
  },

  listSubCategories(categoryCode?: string): Promise<SubCategory[]> {
    return request<SubCategory[]>("/item-categories/subcategories", {
      query: categoryCode ? { category: categoryCode } : undefined,
    });
  },

  createSubCategory(payload: {
    categoryId: string;
    label: string;
  }): Promise<SubCategory> {
    return request<SubCategory>("/item-categories/subcategories", {
      method: "POST",
      body: payload,
    });
  },

  updateSubCategory(id: string, payload: { label: string }): Promise<SubCategory> {
    return request<SubCategory>(
      `/item-categories/subcategories/${encodeURIComponent(id)}`,
      { method: "PATCH", body: payload },
    );
  },

  deleteSubCategory(id: string): Promise<void> {
    return request<void>(
      `/item-categories/subcategories/${encodeURIComponent(id)}`,
      { method: "DELETE" },
    );
  },

  listItems(options?: { includeInactive?: boolean; colorId?: string }): Promise<CatalogListItem[]> {
    const params = new URLSearchParams();
    if (options?.includeInactive) params.set("includeInactive", "true");
    if (options?.colorId) params.set("colorId", options.colorId);
    const q = params.toString();
    return request<CatalogListItem[]>(`/items${q ? `?${q}` : ""}`);
  },

  getItem(id: string): Promise<CatalogItem> {
    return request<CatalogItem>(`/items/${encodeURIComponent(id)}`);
  },

  createItem(payload: CreateItemPayload): Promise<CatalogItem> {
    return request<CatalogItem>("/items", { method: "POST", body: payload });
  },

  updateItem(id: string, payload: UpdateItemPayload): Promise<CatalogItem> {
    return request<CatalogItem>(`/items/${encodeURIComponent(id)}`, {
      method: "PATCH",
      body: payload,
    });
  },

  updateItemWithImage(
    id: string,
    payload: UpdateItemPayload,
    file: File,
  ): Promise<CatalogItem> {
    const fd = new FormData();
    if (payload.name !== undefined) fd.append("name", payload.name);
    if (payload.categoryId !== undefined) fd.append("categoryId", payload.categoryId);
    if (payload.sku !== undefined) fd.append("sku", payload.sku ?? "");
    if (payload.barcode !== undefined) fd.append("barcode", payload.barcode ?? "");
    // null = the box was emptied: sent as "" so the server clears the price
    // (an empty price means "work it out from cost × margin").
    if (payload.defaultPurchaseUnitCostEur !== undefined) {
      fd.append("defaultPurchaseUnitCostEur", String(payload.defaultPurchaseUnitCostEur ?? ""));
    }
    // G-121 S3: the side of IVA the cost was typed on (required with a cost).
    if (payload.defaultPurchaseUnitCostBasis) {
      fd.append("defaultPurchaseUnitCostBasis", payload.defaultPurchaseUnitCostBasis);
    }
    if (payload.defaultSaleUnitPriceEur !== undefined) {
      fd.append("defaultSaleUnitPriceEur", String(payload.defaultSaleUnitPriceEur ?? ""));
    }
    if (payload.subCategoryId !== undefined) {
      if (payload.subCategoryId) fd.append("subCategoryId", payload.subCategoryId);
    }
    if (payload.reorderThreshold !== undefined && payload.reorderThreshold !== null) {
      fd.append("reorderThreshold", String(payload.reorderThreshold));
    }
    if (payload.diameterCm !== undefined && payload.diameterCm !== null) {
      fd.append("diameterCm", String(payload.diameterCm));
    }
    if (payload.depthCm !== undefined && payload.depthCm !== null) {
      fd.append("depthCm", String(payload.depthCm));
    }
    if (payload.isActive !== undefined) fd.append("isActive", String(payload.isActive));
    if (payload.colorId !== undefined) {
      // To clear a color, use the JSON updateItem.
      if (payload.colorId) fd.append("colorId", payload.colorId);
    }
    fd.append("image", file, file.name);
    return formRequest<CatalogItem>(
      `/items/${encodeURIComponent(id)}/with-image`,
      fd,
      { method: "PATCH" },
    );
  },

  createItemWithImage(payload: CreateItemPayload, file: File): Promise<CatalogItem> {
    const fd = new FormData();
    fd.append("name", payload.name);
    fd.append("categoryId", payload.categoryId);
    fd.append("defaultUom", payload.defaultUom);
    fd.append("isPerishable", String(payload.isPerishable ?? false));
    if (payload.confirmDuplicateOf?.length) {
      fd.append("confirmDuplicateOf", payload.confirmDuplicateOf.join(","));
    }
    if (payload.sku) fd.append("sku", payload.sku);
    if (payload.barcode) fd.append("barcode", payload.barcode);
    if (payload.defaultPurchaseUnitCostEur !== undefined) {
      fd.append("defaultPurchaseUnitCostEur", String(payload.defaultPurchaseUnitCostEur));
    }
    if (payload.defaultPurchaseUnitCostBasis) {
      fd.append("defaultPurchaseUnitCostBasis", payload.defaultPurchaseUnitCostBasis);
    }
    if (payload.defaultSaleUnitPriceEur !== undefined) {
      fd.append("defaultSaleUnitPriceEur", String(payload.defaultSaleUnitPriceEur));
    }
    if (payload.subCategoryId) fd.append("subCategoryId", payload.subCategoryId);
    if (payload.reorderThreshold !== undefined && payload.reorderThreshold !== null) {
      fd.append("reorderThreshold", String(payload.reorderThreshold));
    }
    if (payload.diameterCm !== undefined && payload.diameterCm !== null) {
      fd.append("diameterCm", String(payload.diameterCm));
    }
    if (payload.depthCm !== undefined && payload.depthCm !== null) {
      fd.append("depthCm", String(payload.depthCm));
    }
    if (payload.colorId) fd.append("colorId", payload.colorId);
    fd.append("image", file, file.name);
    return formRequest<CatalogItem>("/items/with-image", fd);
  },

  /**
   * Send an image to the server-side background-removal service.
   * Returns the processed PNG as a File (so it can be passed straight to
   * createItemWithImage / updateItemWithImage / createPayrollAdjustment).
   *
   * Throws an ApiError on 4xx/5xx; callers should catch and show the
   * "use original photo?" fallback prompt.
   */
  async removeBackground(file: File): Promise<File> {
    const url = new URL(`${BASE_URL}/images/remove-background`);
    if (!state.accessToken) {
      throw buildError(401, { message: "Not authenticated" });
    }
    const fd = new FormData();
    fd.append("image", file, file.name);

    const response = await fetch(url.toString(), {
      method: "POST",
      headers: {
        Authorization: `Bearer ${state.accessToken}`,
      },
      body: fd,
      credentials: "omit",
    });

    if (!response.ok) {
      let body: unknown = null;
      try {
        body = await response.json();
      } catch {
        /* binary error responses are rare here; ignore */
      }
      throw buildError(response.status, body);
    }

    const blob = await response.blob();
    // Strip the extension and use .png since output is always transparent PNG.
    const baseName = file.name.replace(/\.[^.]+$/, "");
    return new File([blob], `${baseName}.png`, { type: "image/png" });
  },

  /**
   * G-89: catalogue matches for the Inventory page's "0 in stock" group.
   * Capped server-side.
   */
  searchItems(q: string, limit = 12): Promise<CatalogItem[]> {
    return request<CatalogItem[]>("/items/search", {
      query: { q, limit: String(limit) },
    });
  },

  /** G-121 S3: answers with the batch — its net money and how it was given. */
  receiveStock(payload: ReceiveStockPayload): Promise<ReceivedBatchMoney> {
    return request<ReceivedBatchMoney>("/inventory/receive-single-use", { method: "POST", body: payload });
  },

  /**
   * G-84 — the CRM's read of this shop's storage boxes.
   *
   * A manager could see box CONTENTS on the Inventory page from the day boxes
   * shipped (a box is a zone, so its stock was always in the balances), but
   * the boxes THEMSELVES — which exist, what they are called, whether one was
   * retired — lived only on the tablet. Issuing and printing stay on the
   * tablet, where the label comes out of the printer.
   */
  listBoxes(
    locationId: string,
    opts: { includeRetired?: boolean } = {},
  ): Promise<{ locationId: string; boxes: BoxSummary[] }> {
    return request<{ locationId: string; boxes: BoxSummary[] }>("/boxes", {
      query: {
        locationId,
        ...(opts.includeRetired ? { includeRetired: "true" } : {}),
      },
    });
  },

  transferStock(payload: TransferStockPayload): Promise<unknown> {
    return request("/inventory/transfer", { method: "POST", body: payload });
  },

  transferBetweenLocations(payload: TransferBetweenLocationsPayload): Promise<unknown> {
    return request("/inventory/transfer-between-locations", {
      method: "POST",
      body: payload,
    });
  },

  getBalance(filters: BalanceFilters): Promise<InventoryBalance[]> {
    return request<InventoryBalance[]>("/inventory/balance", {
      query: {
        locationId: filters.locationId,
        zoneId: filters.zoneId,
        itemId: filters.itemId,
        categoryId: filters.categoryId,
        minDiameterCm:
          filters.minDiameterCm != null ? String(filters.minDiameterCm) : undefined,
        minDepthCm:
          filters.minDepthCm != null ? String(filters.minDepthCm) : undefined,
      },
    });
  },

  receiveFlowerBatch(payload: ReceiveFlowerBatchPayload): Promise<ReceivedBatchMoney> {
    return request<ReceivedBatchMoney>("/inventory/receive-flower-batch", { method: "POST", body: payload });
  },

  /**
   * G-73: `photo` is the picture of what is being thrown away. Optional — with
   * no file this posts the same JSON body it always did, because a camera that
   * will not open must never stop a loss being recorded.
   */
  logWaste(payload: LogWastePayload, photo?: File | null): Promise<unknown> {
    if (!photo) {
      return request("/inventory/waste", { method: "POST", body: payload });
    }
    const form = new FormData();
    for (const [key, value] of Object.entries(payload)) {
      if (value == null) continue;
      form.append(key, String(value));
    }
    form.append("photo", photo);
    // Multipart goes through formRequest — `request` would JSON-stringify it.
    return formRequest("/inventory/waste", form);
  },

  adjustStock(payload: AdjustStockPayload): Promise<AdjustStockResponse> {
    return request<AdjustStockResponse>("/inventory/adjust-stock", {
      method: "POST",
      body: payload,
    });
  },

  listActiveBatches(params: {
    locationId: string;
    itemId: string;
    zoneId?: string;
  }): Promise<ActiveBatchRow[]> {
    return request<ActiveBatchRow[]>("/inventory/active-batches", {
      query: {
        locationId: params.locationId,
        itemId: params.itemId,
        zoneId: params.zoneId,
      },
    });
  },

  listReceivedBatches(params: {
    locationId: string;
    q?: string;
    limit?: number;
    offset?: number;
  }): Promise<ReceivedBatchHistoryListResponse> {
    return request<ReceivedBatchHistoryListResponse>("/inventory/received-batches", {
      query: {
        locationId: params.locationId,
        ...(params.q?.trim() ? { q: params.q.trim() } : {}),
        ...(params.limit != null ? { limit: String(params.limit) } : {}),
        ...(params.offset != null ? { offset: String(params.offset) } : {}),
      },
    });
  },

  updateReceivedBatch(
    id: string,
    body: UpdateReceivedBatchPayload,
  ): Promise<ReceivedBatchHistoryRow> {
    return request<ReceivedBatchHistoryRow>(`/inventory/received-batches/${id}`, {
      method: "PATCH",
      body,
    });
  },

  listSuppliers(includeInactive = false): Promise<Supplier[]> {
    return request<Supplier[]>("/suppliers", {
      query: includeInactive ? { includeInactive: "true" } : undefined,
    });
  },

  createSupplier(payload: CreateSupplierPayload): Promise<Supplier> {
    return request<Supplier>("/suppliers", { method: "POST", body: payload });
  },

  updateSupplier(id: string, payload: UpdateSupplierPayload): Promise<Supplier> {
    return request<Supplier>(`/suppliers/${id}`, { method: "PATCH", body: payload });
  },

  getSupplierYield(
    supplierId: string,
    query?: { from?: string; to?: string; itemId?: string },
  ): Promise<YieldRow[]> {
    return request<YieldRow[]>(`/suppliers/${supplierId}/yield`, {
      query: {
        from: query?.from,
        to: query?.to,
        itemId: query?.itemId,
      },
    });
  },

  getItemYield(
    itemId: string,
    query?: { from?: string; to?: string; supplierId?: string },
  ): Promise<ItemYieldResponse> {
    return request<ItemYieldResponse>(`/items/${itemId}/yield`, {
      query: {
        from: query?.from,
        to: query?.to,
        supplierId: query?.supplierId,
      },
    });
  },

  listBouquetTemplates(
    locationId?: string,
    colorId?: string,
  ): Promise<BouquetTemplate[]> {
    const query: Record<string, string> = {};
    if (locationId) query.locationId = locationId;
    if (colorId) query.colorId = colorId;
    return request<BouquetTemplate[]>("/bouquet-templates", {
      query: Object.keys(query).length ? query : undefined,
    });
  },

  createBouquetTemplate(payload: CreateBouquetTemplatePayload): Promise<BouquetTemplate> {
    return request<BouquetTemplate>("/bouquet-templates", { method: "POST", body: payload });
  },

  createBouquetTemplateWithImage(
    payload: CreateBouquetTemplatePayload,
    file: File,
  ): Promise<BouquetTemplate> {
    const fd = new FormData();
    fd.append("name", payload.name);
    if (payload.description) fd.append("description", payload.description);
    if (payload.locationId) fd.append("locationId", payload.locationId);
    if (payload.isActive !== undefined) {
      fd.append("isActive", String(payload.isActive));
    }
    fd.append("lines", JSON.stringify(payload.lines));
    fd.append("image", file, file.name);
    return formRequest<BouquetTemplate>("/bouquet-templates/with-image", fd);
  },

  fetchBouquetTemplateImageBlobUrl(id: string): Promise<string | null> {
    return fetchBlobUrlOrNull(
      `/bouquet-templates/${encodeURIComponent(id)}/image`,
    );
  },

  async fetchItemImageBlobUrl(
    itemId: string,
    options?: ItemImageVariant,
  ): Promise<string | null> {
    const size: ItemImageBlobSize = options?.size === "thumb" ? "thumb" : "full";
    return acquireItemImageBlobUrl(itemId, size, options?.version, () =>
      rawFetchItemImageBlobUrl(itemId, options),
    );
  },

  releaseItemImageBlobUrl(itemId: string, options?: ItemImageVariant): void {
    const size: ItemImageBlobSize = options?.size === "thumb" ? "thumb" : "full";
    releaseCachedItemImageBlobUrl(itemId, size, options?.version);
  },

  updateBouquetTemplate(
    id: string,
    payload: UpdateBouquetTemplatePayload,
  ): Promise<BouquetTemplate> {
    return request<BouquetTemplate>(`/bouquet-templates/${id}`, { method: "PATCH", body: payload });
  },

  listBouquetBuilds(locationId: string): Promise<unknown[]> {
    return request<unknown[]>(`/bouquet-builds`, {
      query: { locationId },
    });
  },

  createBouquetBuild(payload: CreateBouquetBuildPayload): Promise<BouquetBuildSummary> {
    return request<BouquetBuildSummary>("/bouquet-builds", { method: "POST", body: payload });
  },

  createBouquetComplete(payload: CreateBouquetCompletePayload): Promise<BouquetBuildSummary> {
    return request<BouquetBuildSummary>("/bouquet-builds/complete", { method: "POST", body: payload });
  },

  finalizeBouquetBuild(buildId: string): Promise<BouquetBuildSummary> {
    return request<BouquetBuildSummary>(`/bouquet-builds/${buildId}/finalize`, { method: "POST", body: {} });
  },

  voidBouquetBuild(buildId: string): Promise<unknown> {
    return request(`/bouquet-builds/${buildId}/void`, { method: "POST", body: {} });
  },

  /** No `locationId` = every shop (owner/admin only; others are scoped by the server). */
  listBouquetsInStock(locationId?: string): Promise<BouquetBuildSummary[]> {
    return request<BouquetBuildSummary[]>("/bouquet-builds/in-stock", {
      query: locationId ? { locationId } : undefined,
    });
  },

  /**
   * Location-wide flower cards for the phone bouquet builder (managers/owners).
   * Same feed as the shop-floor tablet, reached with a normal JWT.
   */
  listBouquetBuilderItems(locationId: string): Promise<BouquetBuilderItem[]> {
    return request<BouquetBuilderItem[]>("/bouquet-builds/builder-items", {
      query: { locationId },
    });
  },

  getActiveRoll(
    locationId: string,
    itemId: string,
  ): Promise<ActiveConsumableRollResponse | null> {
    return request<ActiveConsumableRollResponse | null>("/consumables/active-roll", {
      query: { locationId, itemId },
    });
  },

  listPaperRolls(locationId: string): Promise<PaperRollRow[]> {
    return request<PaperRollRow[]>("/consumables/paper-rolls", {
      query: { locationId },
    });
  },

  /** @deprecated Use listPaperRolls (identical; hits legacy path). */
  listFrontRolls(locationId: string): Promise<FrontRollRow[]> {
    return request<FrontRollRow[]>("/consumables/front-rolls", {
      query: { locationId },
    });
  },

  moveConsumableBatchToFront(payload: {
    locationId: string;
    batchId: string;
    fromZoneId: string;
    toZoneId: string;
  }): Promise<{ ok: boolean; batchId: string }> {
    return request("/consumables/move-batch-to-front", { method: "POST", body: payload });
  },

  openConsumableRoll(payload: {
    locationId: string;
    zoneId: string;
    itemId: string;
    batchId: string;
  }): Promise<unknown> {
    return request("/consumables/open-roll", { method: "POST", body: payload });
  },

  consumeConsumable(payload: {
    locationId: string;
    batchId: string;
    itemId: string;
    sizePreset?: ConsumablePreset;
    customCm?: number;
    bouquetBuildId?: string;
  }): Promise<unknown> {
    return request("/consumables/consume", { method: "POST", body: payload });
  },

  finishConsumableRoll(payload: {
    locationId: string;
    batchId: string;
    notes?: string;
  }): Promise<unknown> {
    return request("/consumables/finish-roll", { method: "POST", body: payload });
  },

  getConsumableRollSummary(batchId: string): Promise<ConsumableRollSummary> {
    return request<ConsumableRollSummary>("/consumables/roll-summary", {
      query: { batchId },
    });
  },

  createUser(payload: CreateUserPayload): Promise<UserListEntry> {
    return request("/users", { method: "POST", body: payload });
  },

  listUsers(): Promise<UserListEntry[]> {
    return request<UserListEntry[]>("/users");
  },

  /**
   * G-105: what this person has done. Open to managers, who get their own
   * shop's floor rows and no security stream — the server decides both, so
   * there is nothing to pass here but the page size.
   *
   * (`GET /users/:id/assignments` still exists on the server; the shop-posting
   * history it serves left the UI when this replaced it.)
   */
  /**
   * G-136: a colleague forgot their password — the server emails a reset link
   * to their own address and they choose the new one. Nobody else sees it.
   */
  sendPasswordResetEmail(userId: string): Promise<void> {
    return request<void>(`/users/${userId}/password-reset-email`, { method: "POST" });
  },

  /** G-136: a fresh invitation; the old link stops working. Owner-only. */
  resendInvite(userId: string): Promise<UserListEntry> {
    return request<UserListEntry>(`/users/${userId}/invite`, { method: "POST" });
  },

  /** G-136: the pending invitation stops working; the person stays on the team. */
  cancelInvite(userId: string): Promise<UserListEntry> {
    return request<UserListEntry>(`/users/${userId}/invite`, { method: "DELETE" });
  },

  listUserActivity(userId: string, take = 10): Promise<UserActivityEntry[]> {
    return request<UserActivityEntry[]>(
      `/users/${userId}/activity?take=${take}`,
    );
  },

  /** Self-service name/phone; the server edits the signed-in user only. */
  patchMyContact(payload: UpdateMyContactPayload): Promise<UserListEntry> {
    return request<UserListEntry>("/users/me/contact", {
      method: "PATCH",
      body: payload,
    });
  },

  /**
   * G-85 S6 — my own language. `null` CLEARS it, which is not the same as
   * choosing English: with no preference the kiosk follows the tablet.
   */
  patchMyLanguage(language: AppLanguage | null): Promise<UserListEntry> {
    return request<UserListEntry>("/users/me/language", {
      method: "PATCH",
      body: { language },
    });
  },

  /** G-85 S6 — Manage team: set somebody else's language. */
  patchUserLanguage(
    userId: string,
    language: AppLanguage | null,
  ): Promise<UserListEntry> {
    return request<UserListEntry>(`/users/${userId}/language`, {
      method: "PATCH",
      body: { language },
    });
  },

  patchUserContact(
    userId: string,
    payload: UpdateUserContactPayload,
  ): Promise<UserListEntry> {
    return request<UserListEntry>(`/users/${userId}/contact`, {
      method: "PATCH",
      body: payload,
    });
  },

  uploadUserWorkContract(userId: string, file: File): Promise<UserListEntry> {
    const form = new FormData();
    form.append("file", file);
    return formRequest<UserListEntry>(`/users/${userId}/work-contract`, form);
  },

  async fetchUserWorkContractBlobUrl(userId: string): Promise<string | null> {
    try {
      const blob = await fetchAuthorizedBlob(
        `/users/${encodeURIComponent(userId)}/work-contract`,
      );
      return URL.createObjectURL(blob);
    } catch {
      return null;
    }
  },

  assignUserLocation(
    userId: string,
    payload: AssignUserLocationPayload,
  ): Promise<UserAssignmentRecord> {
    return request<UserAssignmentRecord>(`/users/${userId}/assignment`, {
      method: "PATCH",
      body: payload,
    });
  },

  patchUserCompensation(
    userId: string,
    payload: UpdateUserCompensationPayload,
  ): Promise<UserListEntry> {
    return request<UserListEntry>(`/users/${userId}/compensation`, {
      method: "PATCH",
      body: payload,
    });
  },
  /** G-103 S2: pay day + monthly salary (owner-only). */
  patchUserPayTerms(
    userId: string,
    payload: UpdateUserPayTermsPayload,
  ): Promise<UserListEntry> {
    return request<UserListEntry>(`/users/${userId}/pay-terms`, {
      method: "PATCH",
      body: payload,
    });
  },

  /** G-163 (D-78): `lastWorkingDay` ("YYYY-MM-DD") is required by the server for a salaried person. */
  deleteUser(userId: string, lastWorkingDay?: string): Promise<void> {
    return request<void>(`/users/${encodeURIComponent(userId)}`, {
      method: "DELETE",
      ...(lastWorkingDay ? { query: { lastWorkingDay } } : {}),
    });
  },

  createLocation(payload: CreateLocationPayload): Promise<Location> {
    return request<Location>("/locations", { method: "POST", body: payload });
  },

  createSale(payload: CreateSalePayload): Promise<Sale> {
    return request<Sale>("/sales", { method: "POST", body: payload });
  },

  listSales(
    locationId?: string,
    period?: { from: string; to: string },
    /** G-151: Sales records also lists the undone sales (they count in no total). */
    options: { includeVoided?: boolean } = {},
  ): Promise<Sale[]> {
    return request<Sale[]>("/sales", {
      query: {
        locationId,
        from: period?.from,
        to: period?.to,
        includeVoided: options.includeVoided ? "true" : undefined,
      },
    });
  },

  listMySales(query: ListMySalesQuery = {}): Promise<Sale[]> {
    return request<Sale[]>("/sales/me", {
      query: { from: query.from, to: query.to },
    });
  },

  /** G-169: the period's totals over the same shop and Barcelona days as `listSales`. */
  getSalesTotals(
    locationId?: string,
    period?: { from: string; to: string },
  ): Promise<SalePeriodTotals> {
    return request<SalePeriodTotals>("/sales/totals", {
      query: { locationId, from: period?.from, to: period?.to },
    });
  },

  /** G-169: my own sales' totals, by the same rule. */
  getMySalesTotals(query: ListMySalesQuery = {}): Promise<SalePeriodTotals> {
    return request<SalePeriodTotals>("/sales/me/totals", {
      query: { from: query.from, to: query.to },
    });
  },

  /**
   * G-162: the refunds GIVEN in a period of Barcelona days, each with what it
   * takes off the totals (subtracted on the day it was given).
   */
  listSaleRefunds(
    locationId?: string,
    period?: { from: string; to: string },
  ): Promise<PeriodSaleRefund[]> {
    return request<PeriodSaleRefund[]>("/sales/refunds", {
      query: { locationId, from: period?.from, to: period?.to },
    });
  },

  /** G-162: the refund window's live figures; writes nothing. */
  previewSaleRefund(saleId: string, lines: SaleRefundLinePayload[]): Promise<SaleRefundPreview> {
    return request<SaleRefundPreview>(`/sales/${saleId}/refunds/preview`, {
      method: "POST",
      body: { lines },
    });
  },

  /** G-162: give money back on a sale, by lines. */
  createSaleRefund(saleId: string, payload: CreateSaleRefundPayload): Promise<SaleRefundRow> {
    return request<SaleRefundRow>(`/sales/${saleId}/refunds`, { method: "POST", body: payload });
  },

  /** G-162 (owner only): remove a mistaken refund; it comes back on today's totals. */
  removeSaleRefund(refundId: string, reason: string): Promise<SaleRefundRow> {
    return request<SaleRefundRow>(`/sales/refunds/${refundId}/remove`, {
      method: "POST",
      body: { reason },
    });
  },

  /** G-166: Shopify refunds whose stock question is still open (the actor's shops). */
  listRefundStockToCheck(locationId?: string): Promise<RefundStockToCheck[]> {
    return request<RefundStockToCheck[]>("/sales/refunds/stock-to-check", {
      query: { locationId },
    });
  },

  /** G-166: a Shopify refund's stock question — its refunded lines, money locked. */
  getRefundStockQuestion(refundId: string): Promise<RefundStockQuestion> {
    return request<RefundStockQuestion>(`/sales/refunds/${refundId}/stock`);
  },

  /** G-166: the answer — units back on the shelf per line; none = nothing came back. */
  answerRefundStock(
    refundId: string,
    lines: Array<{ saleLineId: string; restockQty: number }>,
  ): Promise<SaleRefundRow> {
    return request<SaleRefundRow>(`/sales/refunds/${refundId}/stock`, {
      method: "POST",
      body: { lines },
    });
  },

  /** G-162: refunds of my own sales, given between two instants. */
  listMySaleRefunds(query: ListMySalesQuery = {}): Promise<PeriodSaleRefund[]> {
    return request<PeriodSaleRefund[]>("/sales/refunds/me", {
      query: { from: query.from, to: query.to },
    });
  },

  getSale(id: string): Promise<Sale> {
    return request<Sale>(`/sales/${id}`);
  },

  listShifts(query: ListShiftsQuery = {}): Promise<Shift[]> {
    return request<Shift[]>("/shifts", {
      query: {
        locationId: query.locationId,
        from: query.from,
        to: query.to,
        userId: query.userId,
      },
    });
  },

  listMyShifts(query: ListMyShiftsQuery = {}): Promise<Shift[]> {
    return request<Shift[]>("/shifts/me", {
      query: { from: query.from, to: query.to },
    });
  },

  listMyEarnings(query: { from: string; to: string }): Promise<MyWorkDayEarnings[]> {
    return request<MyWorkDayEarnings[]>("/shifts/me/earnings", {
      query: { from: query.from, to: query.to },
    });
  },

  createShift(payload: CreateShiftPayload): Promise<Shift> {
    return request<Shift>("/shifts", { method: "POST", body: payload });
  },

  bulkCreateShifts(payload: BulkCreateShiftsPayload): Promise<BulkCreateShiftsResponse> {
    return request<BulkCreateShiftsResponse>("/shifts/bulk", {
      method: "POST",
      body: payload,
    });
  },

  updateShift(id: string, payload: UpdateShiftPayload): Promise<Shift> {
    return request<Shift>(`/shifts/${id}`, { method: "PATCH", body: payload });
  },

  deleteShift(id: string): Promise<{ id: string }> {
    return request<{ id: string }>(`/shifts/${id}`, { method: "DELETE" });
  },

  clockIn(id: string): Promise<Shift> {
    return request<Shift>(`/shifts/${id}/clock-in`, {
      method: "POST",
      body: {},
    });
  },

  listTasks(query: ListTasksQuery = {}): Promise<Task[]> {
    return request<Task[]>("/tasks", {
      query: {
        locationId: query.locationId,
        from: query.from,
        to: query.to,
        status: query.status,
        assigneeUserId: query.assigneeUserId,
      },
    });
  },

  listMyTasks(query: ListTasksQuery = {}): Promise<Task[]> {
    return request<Task[]>("/tasks/me", {
      query: {
        from: query.from,
        to: query.to,
        status: query.status,
        assigneeUserId: query.assigneeUserId,
      },
    });
  },

  listAssignableUsers(locationId?: string): Promise<AssignableUser[]> {
    return request<AssignableUser[]>("/tasks/assignable-users", {
      query: locationId ? { locationId } : undefined,
    });
  },

  createTask(form: FormData): Promise<Task> {
    return formRequest<Task>("/tasks", form);
  },

  updateTask(id: string, payload: UpdateTaskPayload): Promise<Task> {
    return request<Task>(`/tasks/${encodeURIComponent(id)}`, {
      method: "PATCH",
      body: payload,
    });
  },

  completeTask(id: string, form: FormData): Promise<Task> {
    return formRequest<Task>(`/tasks/${encodeURIComponent(id)}/complete`, form);
  },

  cancelTask(id: string, payload: { reason?: string }): Promise<Task> {
    return request<Task>(`/tasks/${encodeURIComponent(id)}/cancel`, {
      method: "POST",
      body: payload,
    });
  },

  listTaskSchedules(query: Pick<ListTasksQuery, "locationId"> = {}): Promise<TaskSchedule[]> {
    return request<TaskSchedule[]>("/task-schedules", {
      query: { locationId: query.locationId },
    });
  },

  createTaskSchedule(form: FormData): Promise<TaskSchedule> {
    return formRequest<TaskSchedule>("/task-schedules", form);
  },

  updateTaskSchedule(
    id: string,
    payload: UpdateTaskSchedulePayload,
  ): Promise<TaskSchedule> {
    return request<TaskSchedule>(`/task-schedules/${encodeURIComponent(id)}`, {
      method: "PATCH",
      body: payload,
    });
  },

  deleteTaskSchedule(id: string): Promise<{ id: string }> {
    return request<{ id: string }>(
      `/task-schedules/${encodeURIComponent(id)}`,
      { method: "DELETE" },
    );
  },

  async fetchTaskImageBlobUrl(
    id: string,
    slot: "reference" | "completion",
  ): Promise<string | null> {
    if (!state.accessToken) return null;
    const suffix = slot === "reference" ? "reference-image" : "completion-image";
    const blob = await fetchAuthorizedBlob(
      `/tasks/${encodeURIComponent(id)}/${suffix}`,
    ).catch(() => null);
    return blob ? URL.createObjectURL(blob) : null;
  },

  clockOut(id: string): Promise<Shift> {
    return request<Shift>(`/shifts/${id}/clock-out`, {
      method: "POST",
      body: {},
    });
  },

  /** G-169: the listed deliveries' figures over the same filters, added once on the server. */
  getScheduledDeliveryTotals(
    query: ListDeliveriesQuery & { missingDocument?: boolean } = {},
  ): Promise<DeliveryListTotals> {
    return request<DeliveryListTotals>("/scheduled-deliveries/totals", {
      query: {
        locationId: query.locationId,
        supplierId: query.supplierId,
        status: query.status,
        from: query.from,
        to: query.to,
        missingDocument: query.missingDocument ? "true" : undefined,
      },
    });
  },

  listScheduledDeliveries(
    query: ListDeliveriesQuery = {},
  ): Promise<ScheduledDelivery[]> {
    return request<ScheduledDelivery[]>("/scheduled-deliveries", {
      query: {
        locationId: query.locationId,
        supplierId: query.supplierId,
        status: query.status,
        from: query.from,
        to: query.to,
      },
    });
  },

  getScheduledDelivery(id: string): Promise<ScheduledDelivery> {
    return request<ScheduledDelivery>(`/scheduled-deliveries/${id}`);
  },

  createScheduledDelivery(
    payload: CreateScheduledDeliveryPayload,
  ): Promise<ScheduledDelivery> {
    return request<ScheduledDelivery>("/scheduled-deliveries", {
      method: "POST",
      body: payload,
    });
  },

  updateScheduledDelivery(
    id: string,
    payload: UpdateScheduledDeliveryPayload,
  ): Promise<ScheduledDelivery> {
    return request<ScheduledDelivery>(`/scheduled-deliveries/${id}`, {
      method: "PATCH",
      body: payload,
    });
  },

  cancelScheduledDelivery(id: string): Promise<ScheduledDelivery> {
    return request<ScheduledDelivery>(`/scheduled-deliveries/${id}/cancel`, {
      method: "POST",
      body: {},
    });
  },

  /** G-131 (OD-164): owner/admin — no factura will come for this hand-made delivery. */
  dismissDeliveryFacturaWait(id: string, reason: string): Promise<ScheduledDelivery> {
    return request<ScheduledDelivery>(
      `/scheduled-deliveries/${encodeURIComponent(id)}/dismiss-factura-wait`,
      { method: "POST", body: { reason } },
    );
  },

  /** G-137: the documents of a delivery typed by hand (owner, manager of its shop). */
  listDeliveryDocuments(deliveryId: string): Promise<{ documents: DeliveryDocument[] }> {
    return request<{ documents: DeliveryDocument[] }>(
      `/scheduled-deliveries/${encodeURIComponent(deliveryId)}/documents`,
    );
  },

  /** G-137: add a photo or a PDF; the server writes the Action-log row. */
  addDeliveryDocument(deliveryId: string, file: File): Promise<{ documents: DeliveryDocument[] }> {
    const fd = new FormData();
    fd.append("file", file);
    return formRequest<{ documents: DeliveryDocument[] }>(
      `/scheduled-deliveries/${encodeURIComponent(deliveryId)}/documents`,
      fd,
    );
  },

  /** G-137: delete with a reason (kept, and in the Action log). */
  deleteDeliveryDocument(
    deliveryId: string,
    documentId: string,
    reason: string,
  ): Promise<{ documents: DeliveryDocument[] }> {
    return request<{ documents: DeliveryDocument[] }>(
      `/scheduled-deliveries/${encodeURIComponent(deliveryId)}/documents/${encodeURIComponent(documentId)}/delete`,
      { method: "POST", body: { reason } },
    );
  },

  /** G-137: one document's file as a blob URL (caller revokes); a refusal reaches the caller with its sentence. */
  async fetchDeliveryDocumentBlobUrl(deliveryId: string, documentId: string): Promise<string> {
    const blob = await fetchAuthorizedBlob(
      `/scheduled-deliveries/${encodeURIComponent(deliveryId)}/documents/${encodeURIComponent(documentId)}/file`,
    );
    return URL.createObjectURL(blob);
  },

  /** G-137: hand-made deliveries arrived with no document (owner: all shops; manager: own). */
  countDeliveriesMissingDocument(): Promise<{ count: number }> {
    return request<{ count: number }>("/scheduled-deliveries/missing-documents");
  },

  /** G-164 (KI-165): the owner reopens a closed wait for a factura, with a reason. */
  reopenDeliveryFacturaWait(deliveryId: string, reason: string): Promise<ScheduledDelivery> {
    return request<ScheduledDelivery>(`/scheduled-deliveries/${encodeURIComponent(deliveryId)}/reopen-factura-wait`, {
      method: "POST",
      body: { reason },
    });
  },

  /** G-131: undo the receiving of one line while its stock is untouched. */
  /** G-164 (D-85): the owner moves a delivery nothing was received from to another shop. */
  moveDelivery(deliveryId: string, locationId: string): Promise<ScheduledDelivery> {
    return request<ScheduledDelivery>(`/scheduled-deliveries/${encodeURIComponent(deliveryId)}/move`, {
      method: "POST",
      body: { locationId },
    });
  },

  unreceiveDeliveryLine(deliveryId: string, lineId: string, reason: string): Promise<ScheduledDelivery> {
    return request<ScheduledDelivery>(
      `/scheduled-deliveries/${encodeURIComponent(deliveryId)}/lines/${encodeURIComponent(lineId)}/unreceive`,
      { method: "POST", body: { reason } },
    );
  },

  /**
   * G-121 S2: `photo` is the required picture of the units that arrived
   * damaged (OD-125). Without one this posts the JSON body it always did;
   * with one it goes multipart in the shape `logWaste` uses, and the server
   * stores the photo on the line's receive (IN) movement.
   */
  confirmDeliveryLine(
    deliveryId: string,
    lineId: string,
    payload: ConfirmDeliveryLinePayload,
    photo?: File | null,
  ): Promise<ScheduledDelivery> {
    const path = `/scheduled-deliveries/${deliveryId}/lines/${lineId}/confirm`;
    if (!photo) {
      return request<ScheduledDelivery>(path, { method: "POST", body: payload });
    }
    const form = new FormData();
    for (const [key, value] of Object.entries(payload)) {
      if (value == null) continue;
      form.append(key, String(value));
    }
    form.append("photo", photo);
    // Multipart goes through formRequest — `request` would JSON-stringify it.
    return formRequest<ScheduledDelivery>(path, form);
  },

  /**
   * G-121 S2: the photo on a stock movement — the damaged units of a delivery
   * line, on its receive movement — served by the G-73 route. Object URL or
   * null; the caller revokes it.
   */
  fetchMovementPhotoBlobUrl(movementId: string): Promise<string | null> {
    return fetchBlobUrlOrNull(
      `/inventory/movements/${encodeURIComponent(movementId)}/photo`,
    );
  },

  /** G-59: the item on a pending line learns the barcode on its box. */
  captureDeliveryLineBarcode(
    deliveryId: string,
    lineId: string,
    payload: CaptureDeliveryLineBarcodePayload,
  ): Promise<ScheduledDelivery> {
    return request<ScheduledDelivery>(
      `/scheduled-deliveries/${encodeURIComponent(deliveryId)}/lines/${encodeURIComponent(lineId)}/barcode`,
      { method: "POST", body: payload },
    );
  },

  /**
   * G-127: owner/admin only — delete an uploaded paper that never became a
   * delivery (refused otherwise), so the same PDF can be uploaded again.
   */
  deleteInvoice(id: string): Promise<{ id: string; deleted: true; draftsRemoved: number }> {
    return request<{ id: string; deleted: true; draftsRemoved: number }>(
      `/invoices/${encodeURIComponent(id)}`,
      { method: "DELETE" },
    );
  },

  getInvoice(id: string): Promise<InvoiceDetail> {
    return request<InvoiceDetail>(`/invoices/${encodeURIComponent(id)}`);
  },

  /** G-131: the Supplier papers page — newest upload first, at most 200 rows. */
  listPapers(query: ListPapersQuery = {}): Promise<PaperList> {
    return request<PaperList>("/invoices", {
      query: {
        locationId: query.locationId,
        supplierId: query.supplierId,
        status: query.status,
        paperUse: query.paperUse,
        month: query.month,
        search: query.search,
      },
    });
  },

  /** G-131: every albarán and hand-made delivery still waiting for a factura. */
  listWaitingForFactura(): Promise<WaitingForFacturaList> {
    return request<WaitingForFacturaList>("/invoices/waiting-factura");
  },

  getInvoiceCoverage(invoiceId: string): Promise<InvoiceCoverage> {
    return request<InvoiceCoverage>(`/invoices/${encodeURIComponent(invoiceId)}/coverage`);
  },

  /** G-131: this factura counts these albaranes and hand-made deliveries. */
  linkInvoiceCoverage(
    invoiceId: string,
    payload: { albaranIds: string[]; deliveryIds: string[] },
  ): Promise<InvoiceCoverage> {
    return request<InvoiceCoverage>(`/invoices/${encodeURIComponent(invoiceId)}/coverage`, {
      method: "POST",
      body: payload,
    });
  },

  unlinkInvoiceCoverage(
    invoiceId: string,
    kind: "albaran" | "delivery",
    targetId: string,
  ): Promise<InvoiceCoverage> {
    return request<InvoiceCoverage>(`/invoices/${encodeURIComponent(invoiceId)}/coverage/unlink`, {
      method: "POST",
      body: { kind, targetId },
    });
  },

  /** G-173: a factura's credit notes, or the factura a credit note corrects. */
  getInvoiceCredits(invoiceId: string): Promise<PaperCredits> {
    return request<PaperCredits>(`/invoices/${encodeURIComponent(invoiceId)}/credits`);
  },

  /** G-173: from a factura's page `creditNoteIds`; from a credit note's page `facturaId`. */
  linkInvoiceCredits(
    invoiceId: string,
    payload: { creditNoteIds: string[] } | { facturaId: string },
  ): Promise<PaperCredits> {
    return request<PaperCredits>(`/invoices/${encodeURIComponent(invoiceId)}/credits`, {
      method: "POST",
      body: payload,
    });
  },

  unlinkInvoiceCredit(invoiceId: string, creditNoteId: string): Promise<PaperCredits> {
    return request<PaperCredits>(`/invoices/${encodeURIComponent(invoiceId)}/credits/unlink`, {
      method: "POST",
      body: { creditNoteId },
    });
  },

  /** G-131: a factura with the goods — "no albarán, the goods came with this factura". */
  declareInvoiceCoversNoAlbaran(invoiceId: string): Promise<InvoiceCoverage> {
    return request<InvoiceCoverage>(`/invoices/${encodeURIComponent(invoiceId)}/covers-no-albaran`, {
      method: "POST",
      body: {},
    });
  },

  getInvoicePreview(id: string): Promise<InvoicePreviewDetail> {
    return request<InvoicePreviewDetail>(
      `/invoices/${encodeURIComponent(id)}/preview`,
    );
  },

  uploadInvoice(payload: {
    file: File;
    /**
     * G-129 (OD-160): left out only by the staging page's items-only box —
     * the server then files the paper under the oldest shop the person may
     * write to. Every other upload names the shop.
     */
    locationId?: string;
    supplierId: string;
    /** G-121 S4 (OD-143): what the paper is for — the person says, no default. */
    paperUse: PaperUse;
  }): Promise<InvoiceDetail> {
    const form = new FormData();
    form.append("file", payload.file);
    if (payload.locationId) form.append("locationId", payload.locationId);
    form.append("supplierId", payload.supplierId);
    form.append("paperUse", payload.paperUse);
    return formRequest<InvoiceDetail>("/invoices/upload", form, {
      method: "POST",
    });
  },

  /** G-121 S4 (OD-143): change what a paper is for (owner, or a manager on their shop's papers). */
  setInvoicePaperUse(invoiceId: string, paperUse: PaperUse): Promise<InvoiceDetail> {
    return request<InvoiceDetail>(`/invoices/${encodeURIComponent(invoiceId)}/paper-use`, {
      method: "PATCH",
      body: { paperUse },
    });
  },

  /** G-164: type a factura's number, date, and base and IVA per rate (the reader missed or misread them). */
  typeFacturaDetails(
    invoiceId: string,
    details: {
      invoiceNumber?: string;
      invoiceDate?: string;
      rates?: Array<{ ratePercent: number; baseEur: number; ivaEur: number }>;
    },
  ): Promise<InvoiceDetail> {
    return request<InvoiceDetail>(`/invoices/${encodeURIComponent(invoiceId)}/details`, {
      method: "PATCH",
      body: details,
    });
  },

  /** G-121 S4 (OD-145): this supplier's purchases typed by hand in the six weeks before a factura. */
  getHandTypedNearby(invoiceId: string): Promise<HandTypedNearby> {
    return request<HandTypedNearby>(`/invoices/${encodeURIComponent(invoiceId)}/hand-typed-nearby`);
  },

  /** G-121 S4 (OD-146/OD-147): a factura's paid state and payments — owner only. */
  getInvoicePayments(invoiceId: string): Promise<InvoicePaymentsView> {
    return request<InvoicePaymentsView>(`/invoices/${encodeURIComponent(invoiceId)}/payments`);
  },

  setInvoiceAwaitingPayment(invoiceId: string, awaitingPayment: boolean): Promise<InvoicePaymentsView> {
    return request<InvoicePaymentsView>(`/invoices/${encodeURIComponent(invoiceId)}/payment-terms`, {
      method: "PUT",
      body: { awaitingPayment },
    });
  },

  recordInvoicePayment(invoiceId: string, payload: RecordInvoicePaymentPayload): Promise<InvoicePaymentsView> {
    return request<InvoicePaymentsView>(`/invoices/${encodeURIComponent(invoiceId)}/payments`, {
      method: "POST",
      body: payload,
    });
  },

  removeInvoicePayment(invoiceId: string, paymentId: string, reason: string): Promise<InvoicePaymentsView> {
    return request<InvoicePaymentsView>(
      `/invoices/${encodeURIComponent(invoiceId)}/payments/${encodeURIComponent(paymentId)}/remove`,
      { method: "POST", body: { reason } },
    );
  },

  patchInvoiceLines(
    invoiceId: string,
    payload: { lines: PatchInvoiceLinePayload[] },
  ): Promise<InvoicePreviewDetail> {
    return request<InvoicePreviewDetail>(
      `/invoices/${encodeURIComponent(invoiceId)}/lines`,
      { method: "PATCH", body: payload },
    );
  },

  commitInvoice(
    invoiceId: string,
    payload: CommitInvoicePayload,
  ): Promise<InvoiceDetail> {
    return request<InvoiceDetail>(
      `/invoices/${encodeURIComponent(invoiceId)}/commit`,
      { method: "POST", body: payload },
    );
  },

  getInvoicePdf(invoiceId: string): Promise<Blob> {
    return fetchAuthorizedBlob(
      `/invoices/${encodeURIComponent(invoiceId)}/file`,
    );
  },

  // ── Catalog drafts (staging workspace) ────────────────────────────────────

  listCatalogDrafts(): Promise<CatalogDraftWorkspace> {
    return request<CatalogDraftWorkspace>("/catalog-drafts");
  },

  /** G-129 (OD-160): the items the app created by itself from papers, newest first. */
  listAutoCreatedItems(params: { days?: number } = {}): Promise<AutoCreatedItemRow[]> {
    return request<AutoCreatedItemRow[]>("/catalog-drafts/auto-created", {
      query: params.days ? { days: String(params.days) } : undefined,
    });
  },

  updateCatalogDraft(id: string, payload: UpdateDraftPayload): Promise<CatalogDraft> {
    return request<CatalogDraft>(`/catalog-drafts/${encodeURIComponent(id)}`, {
      method: "PATCH",
      body: payload,
    });
  },

  deleteCatalogDraft(id: string): Promise<{ deleted: boolean }> {
    return request<{ deleted: boolean }>(`/catalog-drafts/${encodeURIComponent(id)}`, {
      method: "DELETE",
    });
  },

  setCatalogDraftPhoto(id: string, file: File): Promise<CatalogDraft> {
    const fd = new FormData();
    fd.append("image", file, file.name);
    return formRequest<CatalogDraft>(
      `/catalog-drafts/${encodeURIComponent(id)}/photo`,
      fd,
    );
  },

  finalizeCatalogDraft(
    id: string,
    payload: { confirmDuplicateOf?: string[] } = {},
  ): Promise<CatalogItem> {
    return request<CatalogItem>(`/catalog-drafts/${encodeURIComponent(id)}/finalize`, {
      method: "POST",
      body: payload,
    });
  },

  /** G-58: one review pass — promote many drafts, suggestions applied where blank. */
  finalizeCatalogDraftsMany(
    payload: FinalizeManyDraftsPayload,
  ): Promise<FinalizeManyDraftsResult> {
    return request<FinalizeManyDraftsResult>("/catalog-drafts/finalize-many", {
      method: "POST",
      body: payload,
    });
  },

  /** G-58: the supplier's 64 px product photo for the review pass. */
  fetchCatalogDraftSupplierThumbnailBlobUrl(id: string): Promise<string | null> {
    return fetchBlobUrlOrNull(
      `/catalog-drafts/${encodeURIComponent(id)}/supplier-thumbnail`,
    );
  },

  /** G-58: the barcode picture, for scanning or typing when the digits were not read. */
  fetchCatalogDraftBarcodeImageBlobUrl(id: string): Promise<string | null> {
    return fetchBlobUrlOrNull(
      `/catalog-drafts/${encodeURIComponent(id)}/barcode-image`,
    );
  },

  createCatalogDraftGroup(payload: CreateDraftGroupPayload): Promise<CatalogDraftGroup> {
    return request<CatalogDraftGroup>("/catalog-drafts/groups", {
      method: "POST",
      body: payload,
    });
  },

  updateCatalogDraftGroup(
    id: string,
    payload: UpdateDraftGroupPayload,
  ): Promise<CatalogDraftGroup> {
    return request<CatalogDraftGroup>(
      `/catalog-drafts/groups/${encodeURIComponent(id)}`,
      { method: "PATCH", body: payload },
    );
  },

  deleteCatalogDraftGroup(id: string): Promise<{ deleted: boolean }> {
    return request<{ deleted: boolean }>(
      `/catalog-drafts/groups/${encodeURIComponent(id)}`,
      { method: "DELETE" },
    );
  },

  async fetchCatalogDraftImageBlobUrl(
    id: string,
    options?: { size?: "thumb" | "full" },
  ): Promise<string | null> {
    const url = new URL(`${BASE_URL}/catalog-drafts/${encodeURIComponent(id)}/image`);
    if (options?.size === "thumb") url.searchParams.set("size", "thumb");
    if (!state.accessToken) return null;
    const response = await fetch(url.toString(), {
      headers: { Authorization: `Bearer ${state.accessToken}` },
      credentials: "omit",
    });
    if (!response.ok) return null;
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  },

  listBlogPosts(): Promise<BlogPostSummary[]> {
    return request<BlogPostSummary[]>("/blog-posts");
  },

  getBlogPost(id: string): Promise<BlogPostDetail> {
    return request<BlogPostDetail>(`/blog-posts/${encodeURIComponent(id)}`);
  },

  createBlogPost(payload: CreateBlogPostPayload): Promise<BlogPostSummary> {
    return request<BlogPostSummary>("/blog-posts", {
      method: "POST",
      body: payload,
    });
  },

  deleteBlogPost(id: string): Promise<void> {
    return request<void>(`/blog-posts/${encodeURIComponent(id)}`, {
      method: "DELETE",
    });
  },

  regenerateBlogPost(id: string): Promise<BlogPostDetail> {
    return request<BlogPostDetail>(`/blog-posts/${encodeURIComponent(id)}/regenerate`, {
      method: "POST",
      body: {},
    });
  },

  requestBlogPostEdit(id: string, editNotes: string): Promise<BlogPostDetail> {
    return request<BlogPostDetail>(`/blog-posts/${encodeURIComponent(id)}/edit`, {
      method: "POST",
      body: { editNotes },
    });
  },

  publishBlogPost(id: string): Promise<BlogPostDetail> {
    return request<BlogPostDetail>(`/blog-posts/${encodeURIComponent(id)}/publish`, {
      method: "POST",
      body: {},
    });
  },

  getPayrollSummary(
    query:
      | { year: number; month: number; locationId?: string; adjustmentsBy?: "booked" | "occurred" }
      | { from: string; to: string; locationId?: string; adjustmentsBy?: "booked" | "occurred" },
  ): Promise<PayrollSummaryResponse> {
    const queryRecord =
      "from" in query
        ? {
            from: query.from,
            to: query.to,
            locationId: query.locationId,
            adjustmentsBy: query.adjustmentsBy,
          }
        : {
            year: String(query.year),
            month: String(query.month),
            locationId: query.locationId,
            adjustmentsBy: query.adjustmentsBy,
          };
    return request<PayrollSummaryResponse>("/finances/payroll", {
      query: queryRecord,
    });
  },

  listPayrollPayments(query: {
    userId: string;
    year: number;
    month: number;
  }): Promise<PayrollPaymentRecord[]> {
    return request<PayrollPaymentRecord[]>("/finances/payroll/payments", {
      query: {
        userId: query.userId,
        year: String(query.year),
        month: String(query.month),
      },
    });
  },

  /** Owner only (G-163): people whose pay day has come and who are still owed. */
  getPayDayDue(): Promise<PayDayDue> {
    return request<PayDayDue>("/finances/payroll/pay-day-due");
  },

  getPayrollPaidMonth(query: {
    userId: string;
    year: number;
    month: number;
  }): Promise<PayrollPaidMonth> {
    return request<PayrollPaidMonth>("/finances/payroll/paid-month", {
      query: {
        userId: query.userId,
        year: String(query.year),
        month: String(query.month),
      },
    });
  },

  createPayrollPayment(payload: CreatePayrollPaymentPayload): Promise<{
    id: string;
    amountEur: string;
    paymentType: "CASH" | "BANK";
    paidAt: string;
    notes: string | null;
    createdAt: string;
  }> {
    return request(`/finances/payroll/payments`, {
      method: "POST",
      body: payload,
    });
  },

  deletePayrollPayment(id: string): Promise<{ id: string; deleted: true }> {
    return request<{ id: string; deleted: true }>(
      `/finances/payroll/payments/${encodeURIComponent(id)}`,
      { method: "DELETE" },
    );
  },

  listPayrollAdjustments(query: {
    userId: string;
    year: number;
    month: number;
  }): Promise<PayrollAdjustmentsResponse> {
    return request<PayrollAdjustmentsResponse>("/finances/payroll/adjustments", {
      query: {
        userId: query.userId,
        year: String(query.year),
        month: String(query.month),
      },
    });
  },

  listMyPayrollAdjustments(query: {
    year: number;
    month: number;
  }): Promise<PayrollAdjustmentsResponse> {
    return request<PayrollAdjustmentsResponse>("/finances/payroll/adjustments/me", {
      query: {
        year: String(query.year),
        month: String(query.month),
      },
    });
  },

  createPayrollAdjustment(
    payload: CreatePayrollAdjustmentPayload,
  ): Promise<PayrollAdjustmentRecord> {
    const fd = new FormData();
    fd.append("kind", payload.kind);
    fd.append("userId", payload.userId);
    fd.append("amountEur", String(payload.amountEur));
    fd.append("reason", payload.reason);
    fd.append("periodYear", String(payload.periodYear));
    fd.append("periodMonth", String(payload.periodMonth));
    if (payload.occurredAt) {
      fd.append("occurredAt", payload.occurredAt);
    }
    if (payload.image) {
      fd.append("image", payload.image);
    }
    return formRequest<PayrollAdjustmentRecord>(
      "/finances/payroll/adjustments",
      fd,
    );
  },

  deletePayrollAdjustment(id: string): Promise<{ id: string; deleted: true }> {
    return request<{ id: string; deleted: true }>(
      `/finances/payroll/adjustments/${encodeURIComponent(id)}`,
      { method: "DELETE" },
    );
  },

  /**
   * Fetch the evidence image for an adjustment as a blob URL (caller must
   * URL.revokeObjectURL when done). Returns null if no image or unauthorized.
   */
  async fetchPayrollAdjustmentImageBlobUrl(
    id: string,
  ): Promise<string | null> {
    if (!state.accessToken) return null;
    const url = new URL(
      `${BASE_URL}/finances/payroll/adjustments/${encodeURIComponent(id)}/image`,
    );
    const response = await fetch(url.toString(), {
      headers: { Authorization: `Bearer ${state.accessToken}` },
      credentials: "omit",
    });
    if (!response.ok) return null;
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  },

  /** G-72: the owner's bug list. Unresolved first, then newest. */
  listBugReports(includeResolved = false): Promise<BugReportListItem[]> {
    return request<BugReportListItem[]>("/bug-reports", {
      query: includeResolved ? { includeResolved: "true" } : undefined,
    });
  },

  setBugReportResolved(id: string, resolved: boolean): Promise<BugReportListItem> {
    return request<BugReportListItem>(
      `/bug-reports/${encodeURIComponent(id)}/resolved`,
      { method: "PATCH", body: { resolved } },
    );
  },

  /**
   * The screenshot, fetched as a blob URL rather than linked directly.
   *
   * It sits behind the same OWNER gate as the report, so an <img src> pointing
   * at the endpoint would arrive without the bearer token and 401. Same reason
   * the task photos are fetched this way.
   */
  bugReportScreenshotUrl(id: string): Promise<string | null> {
    return fetchBlobUrlOrNull(`/bug-reports/${encodeURIComponent(id)}/screenshot`);
  },

  listTickets(): Promise<AppTicketListItem[]> {
    return request<AppTicketListItem[]>("/tickets");
  },

  getTicket(id: string): Promise<AppTicketDetail> {
    return request<AppTicketDetail>(`/tickets/${encodeURIComponent(id)}`);
  },

  createTicket(payload: CreateTicketPayload): Promise<AppTicketListItem> {
    return request<AppTicketListItem>("/tickets", {
      method: "POST",
      body: payload,
    });
  },

  patchTicket(id: string, payload: PatchTicketPayload): Promise<AppTicketListItem> {
    return request<AppTicketListItem>(`/tickets/${encodeURIComponent(id)}`, {
      method: "PATCH",
      body: payload,
    });
  },

  addTicketComment(
    ticketId: string,
    payload: { content: string },
  ): Promise<TicketComment> {
    return request<TicketComment>(`/tickets/${encodeURIComponent(ticketId)}/comments`, {
      method: "POST",
      body: payload,
    });
  },

  getShopifyCredentialStatus(): Promise<ShopifyCredentialStatus> {
    return request<ShopifyCredentialStatus>("/shopify/credentials/status");
  },

  listShopifyPickupLocations(): Promise<ShopifyPickupOptions> {
    return request("/shopify/pickup-locations");
  },

  mapShopifyPickupLocation(locationId: string, shopifyLocationId: string | null): Promise<Location> {
    return request<Location>(`/shopify/pickup-locations/${encodeURIComponent(locationId)}`, {
      method: "PATCH",
      body: { shopifyLocationId },
    });
  },

  setShopifyCredential(
    payload: SetShopifyCredentialPayload,
  ): Promise<ShopifyCredentialStatus> {
    return request<ShopifyCredentialStatus>("/shopify/credentials", {
      method: "PUT",
      body: payload,
    });
  },

  disconnectShopify(): Promise<ShopifyCredentialStatus> {
    return request<ShopifyCredentialStatus>("/shopify/credentials", {
      method: "DELETE",
    });
  },

  // G-122 — the Telegram page.
  getTelegramStatus(): Promise<TelegramStatus> {
    return request<TelegramStatus>("/telegram/status");
  },

  testTelegramGroup(): Promise<TelegramTestResult> {
    return request<TelegramTestResult>("/telegram/group/test", { method: "POST" });
  },

  listTelegramPeople(): Promise<TelegramPeople> {
    return request<TelegramPeople>("/telegram/links");
  },

  linkTelegram(payload: { userId: string; telegramUserId: string }): Promise<TelegramPeople> {
    return request<TelegramPeople>("/telegram/links", { method: "PUT", body: payload });
  },

  unlinkTelegram(userId: string): Promise<TelegramPeople> {
    return request<TelegramPeople>(`/telegram/links/${encodeURIComponent(userId)}`, {
      method: "DELETE",
    });
  },

  testTelegramLink(userId: string): Promise<TelegramTestResult> {
    return request<TelegramTestResult>(
      `/telegram/links/${encodeURIComponent(userId)}/test`,
      { method: "POST" },
    );
  },

  listShopifyProducts(query?: {
    q?: string;
    linked?: ShopifyLinkFilter;
  }): Promise<{ refreshedAt: string | null; variants: ShopifyVariant[] }> {
    return request<{ refreshedAt: string | null; variants: ShopifyVariant[] }>(
      "/shopify/products",
      { query },
    );
  },

  refreshShopifyProducts(): Promise<ShopifyCatalogRefreshResult> {
    return request<ShopifyCatalogRefreshResult>("/shopify/products/refresh", {
      method: "POST",
    });
  },

  getShopifyProduct(shopifyVariantId: string): Promise<ShopifyVariant> {
    return request<ShopifyVariant>(
      `/shopify/products/${encodeURIComponent(shopifyVariantId)}`,
    );
  },

  /** The variant's Shopify photo as a File, ready for a recipe upload. */
  async fetchShopifyProductImageFile(shopifyVariantId: string): Promise<File | null> {
    try {
      const blob = await fetchAuthorizedBlob(
        `/shopify/products/${encodeURIComponent(shopifyVariantId)}/image`,
      );
      const ext = blob.type === "image/png" ? "png" : blob.type === "image/webp" ? "webp" : "jpg";
      return new File([blob], `shopify-${shopifyVariantId}.${ext}`, { type: blob.type });
    } catch {
      return null;
    }
  },

  listShopifyBarcodeMatches(): Promise<ShopifyBarcodeMatches> {
    return request<ShopifyBarcodeMatches>("/shopify/barcode-matches");
  },

  setShopifyLinksBulk(
    links: Array<{ shopifyVariantId: string; itemId: string }>,
  ): Promise<{ linked: number; failed: Array<{ shopifyVariantId: string; message: string }> }> {
    return request("/shopify/links/bulk", { method: "POST", body: { links } });
  },

  /** Sets what one Shopify size stands for; creating and changing are the same call. */
  setShopifyLink(
    payload: CreateShopifyLinkPayload,
  ): Promise<ShopifyLinkResult> {
    return request<ShopifyLinkResult>("/shopify/links", {
      method: "POST",
      body: payload,
    });
  },

  removeShopifyLink(id: string): Promise<void> {
    return request<void>(`/shopify/links/${encodeURIComponent(id)}`, {
      method: "DELETE",
    });
  },

  listShopifyOrders(query?: {
    status?: string;
    locationId?: string;
    /** G-160 (OD-265): owners' list of skipped orders. */
    view?: "skipped";
  }): Promise<ShopifyOrderView[]> {
    return request<ShopifyOrderView[]>("/shopify/orders", { query });
  },

  /** G-160 (OD-263): the menu's counts of web orders that need someone. */
  getWebOrderAttentionCounts(): Promise<WebOrderAttentionCounts> {
    return request<WebOrderAttentionCounts>("/shopify/orders/attention/counts");
  },

  /** G-160 (OD-265): owners take an order nobody accepted out of the queues. */
  skipShopifyOrder(
    id: string,
    body: { reason: ShopifyOrderSkipReason; note?: string },
  ): Promise<ShopifyOrderView> {
    return request<ShopifyOrderView>(`/shopify/orders/${encodeURIComponent(id)}/skip`, {
      method: "POST",
      body,
    });
  },

  unskipShopifyOrder(id: string): Promise<ShopifyOrderView> {
    return request<ShopifyOrderView>(`/shopify/orders/${encodeURIComponent(id)}/unskip`, {
      method: "POST",
    });
  },

  getShopifyOrder(id: string): Promise<ShopifyOrderView> {
    return request<ShopifyOrderView>(`/shopify/orders/${encodeURIComponent(id)}`);
  },

  /** G-143: web orders by shop — the server scopes a manager to their shop. */
  getWebOrdersReport(query: WebOrdersReportQuery): Promise<WebOrdersReport> {
    return request<WebOrdersReport>("/shopify/web-orders-report", { query: { ...query } });
  },

  listWebOrdersReportOrders(
    query: WebOrdersReportQuery & { take: number; skip: number },
  ): Promise<{ rows: WebOrderRow[]; take: number }> {
    return request<{ rows: WebOrderRow[]; take: number }>("/shopify/web-orders-report/orders", {
      query: { ...query, take: String(query.take), skip: String(query.skip) },
    });
  },

  getWebOrderJourney(id: string): Promise<WebOrderJourney> {
    return request<WebOrderJourney>(`/shopify/web-orders-report/orders/${encodeURIComponent(id)}`);
  },

  getWebOrdersPerson(userId: string, query: WebOrdersReportQuery): Promise<WebOrdersPersonReport> {
    return request<WebOrdersPersonReport>(
      `/shopify/web-orders-report/people/${encodeURIComponent(userId)}`,
      { query: { ...query } },
    );
  },

  /** G-167 (OD-283): the office gives an order due later than tomorrow to a shop. */
  assignShopifyOrder(id: string, locationId: string): Promise<ShopifyOrderView> {
    return request<ShopifyOrderView>(
      `/shopify/orders/${encodeURIComponent(id)}/assign`,
      { method: "POST", body: { locationId } },
    );
  },

  /** G-167 (OD-283): "Pass to another shop", with a reason. */
  passShopifyOrder(id: string, locationId: string, reason: string): Promise<ShopifyOrderView> {
    return request<ShopifyOrderView>(
      `/shopify/orders/${encodeURIComponent(id)}/pass`,
      { method: "POST", body: { locationId, reason } },
    );
  },

  /** G-167: how each open shop stands for the order on today's stock. */
  getShopifyOrderShopFit(id: string): Promise<ShopifyShopFit[]> {
    return request<ShopifyShopFit[]>(`/shopify/orders/${encodeURIComponent(id)}/shop-fit`);
  },

  acceptShopifyOrder(
    id: string,
    locationId?: string,
  ): Promise<ShopifyOrderView> {
    return request<ShopifyOrderView>(
      `/shopify/orders/${encodeURIComponent(id)}/accept`,
      { method: "POST", body: { locationId } },
    );
  },

  fulfilShopifyOrder(
    id: string,
    boxAnswers: { boxId: string; takenFromBox: boolean }[] = [],
  ): Promise<ShopifyOrderView> {
    return request<ShopifyOrderView>(
      `/shopify/orders/${encodeURIComponent(id)}/fulfil`,
      { method: "POST", body: boxAnswers.length ? { boxAnswers } : {} },
    );
  },

  reEvaluateShopifyOrder(id: string): Promise<ShopifyOrderView> {
    return request<ShopifyOrderView>(
      `/shopify/orders/${encodeURIComponent(id)}/re-evaluate`,
      { method: "POST" },
    );
  },

  acknowledgeShopifyChange(id: string): Promise<ShopifyOrderView> {
    return request<ShopifyOrderView>(
      `/shopify/orders/${encodeURIComponent(id)}/acknowledge-change`,
      { method: "POST" },
    );
  },

  syncShopifyNow(): Promise<{ ingested: number }> {
    return request<{ ingested: number }>("/shopify/sync", { method: "POST" });
  },

  listCustomerOrders(query: ListCustomerOrdersQuery = {}): Promise<CustomerOrder[]> {
    return request<CustomerOrder[]>("/customer-orders", {
      query: {
        locationId: query.locationId,
        from: query.from,
        to: query.to,
        status: query.status,
        fulfillment: query.fulfillment,
        source: query.source,
        fulfillmentKind: query.fulfillmentKind,
        minTotalEur: query.minTotalEur != null ? String(query.minTotalEur) : undefined,
        preparedByUserId: query.preparedByUserId,
        courierUserId: query.courierUserId,
        search: query.search,
        take: query.take != null ? String(query.take) : undefined,
        skip: query.skip != null ? String(query.skip) : undefined,
      },
    });
  },

  /** Security tab (owner/admin only): account events — logins, PIN issue/view. */
  /** G-149: the AI control page — owners and admins only. */
  aiControlSystems(): Promise<AiControlSystem[]> {
    return request<AiControlSystem[]>("/ai-control");
  },

  /* G-149 S2 — change the editable part of a system's instructions. */
  saveAiInstructionsDraft(
    system: AiEditableSystemKey,
    body: { texts: Record<string, string>; note: string | null },
  ): Promise<void> {
    return request<void>(`/ai-control/${system}/draft`, { method: "PUT", body });
  },

  discardAiInstructionsDraft(system: AiEditableSystemKey): Promise<void> {
    return request<void>(`/ai-control/${system}/draft`, { method: "DELETE" });
  },

  publishAiInstructions(system: AiEditableSystemKey, note: string): Promise<void> {
    return request<void>(`/ai-control/${system}/publish`, { method: "POST", body: { note } });
  },

  /** Put a version back live; 0 = the text in code. */
  makeAiInstructionsLive(system: AiEditableSystemKey, number: number): Promise<void> {
    return request<void>(`/ai-control/${system}/live`, { method: "POST", body: { number } });
  },

  aiInstructionVersions(system: AiEditableSystemKey): Promise<AiInstructionVersions> {
    return request<AiInstructionVersions>(`/ai-control/${system}/versions`);
  },

  aiTestablePastSearches(system: AiEditableSystemKey): Promise<AiTestablePastSearch[]> {
    return request<AiTestablePastSearch[]>(`/ai-control/${system}/past-searches`);
  },

  fetchAiPastSearchPhotoBlobUrl(system: AiEditableSystemKey, searchId: string): Promise<string | null> {
    return fetchBlobUrlOrNull(`/ai-control/${system}/past-searches/${encodeURIComponent(searchId)}/photo`);
  },

  /** Two real, billed calls: the saved draft and the live text on one past search. */
  testAiInstructions(system: AiEditableSystemKey, searchId: string): Promise<AiPhotoSearchTrial> {
    return request<AiPhotoSearchTrial>(`/ai-control/${system}/tests`, { method: "POST", body: { searchId } });
  },

  listAuthAuditLog(
    query: ListAuthAuditLogQuery = {},
  ): Promise<AuthAuditLogEntry[]> {
    return request<AuthAuditLogEntry[]>("/auth/audit-log", {
      query: {
        userId: query.userId,
        event: query.event,
        from: query.from,
        to: query.to,
        includeTokenActivity: query.includeTokenActivity ? "true" : undefined,
        take: query.take != null ? String(query.take) : undefined,
        skip: query.skip != null ? String(query.skip) : undefined,
      },
    });
  },

  /** OD-30: record the buyer's money on an order (owner/manager). */
  recordOrderPayment(
    id: string,
    body: RecordOrderPaymentPayload,
  ): Promise<CustomerOrder> {
    return request<CustomerOrder>(
      `/customer-orders/${encodeURIComponent(id)}/payments`,
      { method: "POST", body },
    );
  },

  /**
   * OD-32: "the customer collected this — record it." Completes a READY
   * pickup order from the office through the one completion engine; a
   * charged price different from the agreed one is flagged, never blocked.
   */
  recordOrderHandover(
    id: string,
    body: {
      method: StaffOrderPaymentMethod;
      amountEur?: number;
      chargedTotalEur?: number;
      /** G-112 (OD-103): answers to "Is this from box X?". */
      boxAnswers?: { boxId: string; takenFromBox: boolean }[];
    },
  ): Promise<CustomerOrder> {
    return request<CustomerOrder>(
      `/customer-orders/${encodeURIComponent(id)}/record-handover`,
      { method: "POST", body },
    );
  },

  /** G-22: commission-by-source toggles. Owner-only on the server. */
  listCommissionRules(): Promise<CommissionRuleView[]> {
    return request<CommissionRuleView[]>("/commission-rules");
  },
  setCommissionRule(
    source: OrderSource,
    commissionEnabled: boolean,
  ): Promise<{ source: OrderSource; commissionEnabled: boolean }> {
    return request(`/commission-rules/${source}`, {
      method: "PATCH",
      body: { commissionEnabled },
    });
  },

  /** G-54: the catalog change log — who created/renamed/archived what. */
  listCatalogAuditLog(
    query: ListCatalogAuditLogQuery = {},
  ): Promise<CatalogAuditEntry[]> {
    return request<CatalogAuditEntry[]>("/catalog-audit-log", {
      query: {
        actorUserId: query.actorUserId,
        entityId: query.entityId,
        action: query.action,
        from: query.from,
        to: query.to,
        take: query.take != null ? String(query.take) : undefined,
        skip: query.skip != null ? String(query.skip) : undefined,
      },
    });
  },

  /** G-115: reverse a catalog change's effect; the log row survives. */
  undoCatalogAction(
    auditLogId: string,
    reason: string,
  ): Promise<{ undone: string; undoRowId: string; effect: string }> {
    return request(
      `/catalog-audit-log/${encodeURIComponent(auditLogId)}/undo`,
      { method: "POST", body: { reason } },
    );
  },

  /** G-115: the whole staging pass undone with one reason. */
  undoCatalogActions(
    auditLogIds: string[],
    reason: string,
  ): Promise<CatalogUndoManyResult> {
    return request<CatalogUndoManyResult>("/catalog-audit-log/undo-many", {
      method: "POST",
      body: { auditLogIds, reason },
    });
  },

  /** G-17: the owner/manager read of the shop-floor action log. */
  listShopAuditLog(
    query: ListShopAuditLogQuery = {},
  ): Promise<ShopAuditLogEntry[]> {
    return request<ShopAuditLogEntry[]>("/shop-mode/audit-log", {
      query: {
        locationId: query.locationId,
        actorUserId: query.actorUserId,
        action: query.action,
        from: query.from,
        to: query.to,
        take: query.take != null ? String(query.take) : undefined,
        skip: query.skip != null ? String(query.skip) : undefined,
      },
    });
  },

  customerOrdersCalendar(query: {
    locationId?: string;
    from: string;
    to: string;
  }): Promise<OrdersCalendarEntry[]> {
    return request<OrdersCalendarEntry[]>("/customer-orders/calendar", {
      query: {
        locationId: query.locationId,
        from: query.from,
        to: query.to,
      },
    });
  },

  getCustomerOrder(id: string): Promise<CustomerOrder> {
    return request<CustomerOrder>(`/customer-orders/${encodeURIComponent(id)}`);
  },

  createCustomerOrder(payload: CreateCustomerOrderPayload): Promise<CustomerOrder> {
    return request<CustomerOrder>("/customer-orders", {
      method: "POST",
      body: payload,
    });
  },

  listOrderableItemsInStock(locationId: string): Promise<OrderableItem[]> {
    return request<OrderableItem[]>("/sales/items-in-stock", {
      query: { locationId },
    });
  },

  // ── G-15: 1-N order reference photos (replaced the single image) ──────────

  listOrderReferencePhotos(id: string): Promise<OrderReferencePhoto[]> {
    return request<OrderReferencePhoto[]>(
      `/customer-orders/${encodeURIComponent(id)}/reference-photos`,
    );
  },

  uploadOrderReferencePhoto(
    id: string,
    file: File,
  ): Promise<OrderReferencePhoto> {
    const form = new FormData();
    form.append("photo", file, file.name);
    return formRequest<OrderReferencePhoto>(
      `/customer-orders/${encodeURIComponent(id)}/reference-photos`,
      form,
    );
  },

  deleteOrderReferencePhoto(
    id: string,
    photoId: string,
  ): Promise<{ ok: true }> {
    return request<{ ok: true }>(
      `/customer-orders/${encodeURIComponent(id)}/reference-photos/${encodeURIComponent(photoId)}`,
      { method: "DELETE" },
    );
  },

  async fetchOrderReferencePhotoBlobUrl(
    id: string,
    photoId: string,
  ): Promise<string | null> {
    const blob = await fetchAuthorizedBlob(
      `/customer-orders/${encodeURIComponent(id)}/reference-photos/${encodeURIComponent(photoId)}`,
    ).catch(() => null);
    return blob ? URL.createObjectURL(blob) : null;
  },

  /** G-16: the courier's delivery-proof bytes for the labeled gallery. */
  async fetchDeliveryProofBlobUrl(jobId: string): Promise<string | null> {
    const blob = await fetchAuthorizedBlob(
      `/delivery-jobs/${encodeURIComponent(jobId)}/proof-photo`,
    ).catch(() => null);
    return blob ? URL.createObjectURL(blob) : null;
  },

  /** G-16: the order's event trail for the detail view. */
  listOrderEvents(id: string): Promise<CustomerOrderEventView[]> {
    return request<CustomerOrderEventView[]>(
      `/customer-orders/${encodeURIComponent(id)}/events`,
    );
  },

  /** G-16: one build's recipe (money fields absent for florists). */
  getBouquetBuildDetail(id: string): Promise<BouquetBuildDetail> {
    return request<BouquetBuildDetail>(
      `/bouquet-builds/${encodeURIComponent(id)}`,
    );
  },

  /** G-16: build photos incl. the courier DELIVERY_PROOF pseudo-entry. */
  /**
   * G-12 staff-plane upload. The route has existed since 2026-07-28 with no
   * client function, so the CRM could list photos but never add one — which
   * left a photo-less bouquet un-justifiable from the Sales page (pre-release
   * fix 2026-09-09). Mirrors the kiosk's floorAddBouquetPhoto.
   */
  addBouquetBuildPhoto(id: string, file: File): Promise<BouquetBuildPhotoEntry> {
    const form = new FormData();
    form.append("photo", file);
    return formRequest<BouquetBuildPhotoEntry>(
      `/bouquet-builds/${encodeURIComponent(id)}/photos`,
      form,
    );
  },

  listBouquetBuildPhotos(id: string): Promise<BouquetBuildPhotoEntry[]> {
    return request<BouquetBuildPhotoEntry[]>(
      `/bouquet-builds/${encodeURIComponent(id)}/photos`,
    );
  },

  async fetchBouquetBuildPhotoBlobUrl(
    id: string,
    photoId: string,
  ): Promise<string | null> {
    const blob = await fetchAuthorizedBlob(
      `/bouquet-builds/${encodeURIComponent(id)}/photos/${encodeURIComponent(photoId)}`,
    ).catch(() => null);
    return blob ? URL.createObjectURL(blob) : null;
  },

  updateCustomerOrder(
    id: string,
    payload: UpdateCustomerOrderPayload,
  ): Promise<CustomerOrder> {
    return request<CustomerOrder>(`/customer-orders/${encodeURIComponent(id)}`, {
      method: "PATCH",
      body: payload,
    });
  },

  confirmCustomerOrder(id: string): Promise<CustomerOrder> {
    return request<CustomerOrder>(
      `/customer-orders/${encodeURIComponent(id)}/confirm`,
      { method: "POST" },
    );
  },

  startCustomerOrderPreparation(id: string): Promise<CustomerOrder> {
    return request<CustomerOrder>(
      `/customer-orders/${encodeURIComponent(id)}/start-preparation`,
      { method: "POST" },
    );
  },

  markCustomerOrderReady(id: string): Promise<CustomerOrder> {
    return request<CustomerOrder>(
      `/customer-orders/${encodeURIComponent(id)}/mark-ready`,
      { method: "POST" },
    );
  },

  cancelCustomerOrder(id: string, payload: { reason?: string }): Promise<CustomerOrder> {
    return request<CustomerOrder>(
      `/customer-orders/${encodeURIComponent(id)}/cancel`,
      { method: "POST", body: payload },
    );
  },

  /** G-141: the sale that completes this order, saved with the completion. */
  ringUpCustomerOrder(
    id: string,
    payload: RingUpOrderPayload,
  ): Promise<{ sale: Sale; order: CustomerOrder }> {
    return request<{ sale: Sale; order: CustomerOrder }>(
      `/customer-orders/${encodeURIComponent(id)}/ring-up`,
      { method: "POST", body: payload },
    );
  },

  linkCustomerOrderSale(id: string, saleId: string): Promise<CustomerOrder> {
    return request<CustomerOrder>(
      `/customer-orders/${encodeURIComponent(id)}/link-sale`,
      { method: "POST", body: { saleId } },
    );
  },

  listDeliveryJobs(query: ListDeliveryJobsQuery = {}): Promise<DeliveryJob[]> {
    return request<DeliveryJob[]>("/delivery-jobs", {
      query: {
        locationId: query.locationId,
        from: query.from,
        to: query.to,
        status: query.status,
        courierUserId: query.courierUserId,
      },
    });
  },

  getDeliveryJob(id: string): Promise<DeliveryJobDetail> {
    return request<DeliveryJobDetail>(`/delivery-jobs/${encodeURIComponent(id)}`);
  },

  updateDeliveryJob(
    id: string,
    payload: UpdateDeliveryJobPayload,
  ): Promise<DeliveryJobDetail> {
    return request<DeliveryJobDetail>(`/delivery-jobs/${encodeURIComponent(id)}`, {
      method: "PATCH",
      body: payload,
    });
  },

  createDeliveryJob(payload: CreateDeliveryJobPayload): Promise<DeliveryJob> {
    return request<DeliveryJob>("/delivery-jobs", { method: "POST", body: payload });
  },

  listDeliveryProblems(): Promise<DeliveryProblem[]> {
    return request<DeliveryProblem[]>("/delivery-jobs/problems");
  },

  listAssignableCouriers(): Promise<AssignableCourier[]> {
    return request<AssignableCourier[]>("/delivery-jobs/assignable-couriers");
  },

  previewDeliveryPayout(
    payload: PreviewDeliveryPayoutPayload,
  ): Promise<AssignmentPreview> {
    return request<AssignmentPreview>("/delivery-jobs/preview-payout", {
      method: "POST",
      body: payload,
    });
  },

  previewDeliveryJobAssignment(
    id: string,
    payload: { courierUserId: string; distanceKm?: number },
  ): Promise<AssignmentPreview> {
    return request<AssignmentPreview>(
      `/delivery-jobs/${encodeURIComponent(id)}/preview-assignment`,
      { method: "POST", body: payload },
    );
  },

  assignDeliveryJob(
    id: string,
    payload: {
      courierUserId: string;
      distanceKm?: number;
      overridePayoutEur?: number;
      overrideCapacity?: boolean;
      overrideSchedule?: boolean;
    },
  ): Promise<DeliveryJob> {
    return request<DeliveryJob>(`/delivery-jobs/${encodeURIComponent(id)}/assign`, {
      method: "POST",
      body: payload,
    });
  },

  /** D-6: the job's audited event timeline for the dispatch History modal. */
  listDeliveryJobEvents(id: string): Promise<DeliveryJobEvent[]> {
    return request<DeliveryJobEvent[]>(
      `/delivery-jobs/${encodeURIComponent(id)}/events`,
    );
  },

  unassignDeliveryJob(id: string): Promise<DeliveryJob> {
    return request<DeliveryJob>(`/delivery-jobs/${encodeURIComponent(id)}/unassign`, {
      method: "POST",
    });
  },

  cancelDeliveryJob(id: string, payload: { reason?: string }): Promise<DeliveryJob> {
    return request<DeliveryJob>(`/delivery-jobs/${encodeURIComponent(id)}/cancel`, {
      method: "POST",
      body: payload,
    });
  },

  markDeliveryJobPaidByClient(id: string): Promise<DeliveryJob> {
    return request<DeliveryJob>(
      `/delivery-jobs/${encodeURIComponent(id)}/mark-paid-by-client`,
      { method: "POST" },
    );
  },

  markDeliveryJobPaidToCourier(id: string): Promise<DeliveryJob> {
    return request<DeliveryJob>(
      `/delivery-jobs/${encodeURIComponent(id)}/mark-paid-to-courier`,
      { method: "POST" },
    );
  },

  /** G-1: owner-only fleet overview for the Manage-couriers page. */
  couriersOverview(): Promise<CourierOverviewRow[]> {
    return request<CourierOverviewRow[]>("/couriers/overview");
  },

  listPayoutRules(): Promise<PayoutRule[]> {
    return request<PayoutRule[]>("/payout-rules");
  },

  createPayoutRule(payload: CreatePayoutRulePayload): Promise<PayoutRule> {
    return request<PayoutRule>("/payout-rules", { method: "POST", body: payload });
  },

  updatePayoutRule(
    id: string,
    payload: { name?: string; isDefault?: boolean; isActive?: boolean },
  ): Promise<PayoutRule> {
    return request<PayoutRule>(`/payout-rules/${encodeURIComponent(id)}`, {
      method: "PATCH",
      body: payload,
    });
  },

  // ── Courier surface (role COURIER; scoped to own jobs server-side) ────────

  courierListJobs(): Promise<DeliveryJob[]> {
    return request<DeliveryJob[]>("/courier/jobs");
  },

  /** G-6: the courier's own "what am I owed?". */
  courierEarnings(query?: { from?: string; to?: string }): Promise<CourierEarnings> {
    return request<CourierEarnings>("/courier/earnings", {
      query: { ...(query?.from ? { from: query.from } : {}), ...(query?.to ? { to: query.to } : {}) },
    });
  },

  /** G-6: unpaid delivered jobs grouped per courier (owner/manager). */
  getCourierSettlement(query?: { from?: string; to?: string }): Promise<SettlementGroup[]> {
    return request<SettlementGroup[]>("/delivery-jobs/settlement", {
      query: { ...(query?.from ? { from: query.from } : {}), ...(query?.to ? { to: query.to } : {}) },
    });
  },

  /** G-6: batch mark-paid — every job keeps its own event row. */
  settleCourierJobs(jobIds: string[]): Promise<{ settled: number }> {
    return request<{ settled: number }>("/delivery-jobs/settlement/mark-paid", {
      method: "POST",
      body: { jobIds },
    });
  },

  courierListHistory(): Promise<DeliveryJob[]> {
    return request<DeliveryJob[]>("/courier/jobs/history");
  },

  listNotifications(query: {
    since?: string;
    unreadOnly?: boolean;
    limit?: number;
  } = {}): Promise<AppNotification[]> {
    return request<AppNotification[]>("/notifications", {
      query: {
        since: query.since,
        unreadOnly: query.unreadOnly ? "true" : undefined,
        limit: query.limit != null ? String(query.limit) : undefined,
      },
    });
  },

  notificationsUnreadCount(): Promise<{ unreadCount: number }> {
    return request<{ unreadCount: number }>("/notifications/unread-count");
  },

  markNotificationRead(id: string): Promise<{ ok: boolean }> {
    return request<{ ok: boolean }>(
      `/notifications/${encodeURIComponent(id)}/read`,
      { method: "POST" },
    );
  },

  markAllNotificationsRead(): Promise<{ ok: boolean; marked: number }> {
    return request<{ ok: boolean; marked: number }>("/notifications/read-all", {
      method: "POST",
    });
  },

  // ---- G-2: the courier's own planning calendar ----

  courierListSchedule(from: string, to: string): Promise<CourierShift[]> {
    return request<CourierShift[]>("/courier/schedule", {
      query: { from, to },
    });
  },

  courierPlanDay(payload: {
    date: string;
    plannedStart?: string;
    plannedEnd?: string;
    notes?: string;
  }): Promise<CourierShift> {
    return request<CourierShift>("/courier/schedule", {
      method: "POST",
      body: payload,
    });
  },

  /** OD-3: the reason is always optional. */
  courierWithdrawDay(id: string, reason?: string): Promise<CourierShift> {
    return request<CourierShift>(
      `/courier/schedule/${encodeURIComponent(id)}`,
      { method: "DELETE", body: reason ? { reason } : {} },
    );
  },

  courierConfirmDay(id: string): Promise<CourierShift> {
    return request<CourierShift>(
      `/courier/schedule/${encodeURIComponent(id)}/confirm`,
      { method: "POST" },
    );
  },

  courierEndDay(id: string): Promise<CourierShift> {
    return request<CourierShift>(
      `/courier/schedule/${encodeURIComponent(id)}/end`,
      { method: "POST" },
    );
  },

  courierMyPayoutRule(): Promise<CourierPayoutRuleView> {
    return request<CourierPayoutRuleView>("/courier/payout-rule");
  },

  // ---- G-2: owner planning over any courier's calendar ----

  planningListShifts(query: {
    from: string;
    to: string;
    courierUserId?: string;
  }): Promise<CourierShift[]> {
    return request<CourierShift[]>("/courier-planning", { query });
  },

  planningPlanDay(payload: {
    courierUserId: string;
    date: string;
    plannedStart?: string;
    plannedEnd?: string;
    notes?: string;
  }): Promise<CourierShift> {
    return request<CourierShift>("/courier-planning", {
      method: "POST",
      body: payload,
    });
  },

  planningUpdateShift(
    id: string,
    payload: {
      plannedStart?: string;
      plannedEnd?: string;
      notes?: string;
      cancel?: boolean;
    },
  ): Promise<CourierShift> {
    return request<CourierShift>(
      `/courier-planning/${encodeURIComponent(id)}`,
      { method: "PATCH", body: payload },
    );
  },

  /** G-4: non-terminal problem flare — the job continues after reporting. */
  courierReportProblem(
    id: string,
    message: string,
    geo?: { lat: number; lng: number },
  ): Promise<{ ok: boolean }> {
    return request<{ ok: boolean }>(
      `/courier/jobs/${encodeURIComponent(id)}/problem`,
      { method: "POST", body: { message, ...(geo ?? {}) } },
    );
  },

  courierGetAvailability(): Promise<{ isAvailable: boolean }> {
    return request<{ isAvailable: boolean }>("/courier/availability");
  },

  courierSetAvailability(isAvailable: boolean): Promise<{ isAvailable: boolean }> {
    return request<{ isAvailable: boolean }>("/courier/availability", {
      method: "POST",
      body: { isAvailable },
    });
  },

  /** G-21 amendment: position rides along; the server records it for ASAP
   *  jobs only (how far away is this courier?) and ignores it for planned. */
  courierAcceptJob(
    id: string,
    geo?: { lat: number; lng: number },
  ): Promise<DeliveryJob> {
    return request<DeliveryJob>(`/courier/jobs/${encodeURIComponent(id)}/accept`, {
      method: "POST",
      body: geo ?? {},
    });
  },

  courierArrivedJob(
    id: string,
    geo?: { lat: number; lng: number },
    override?: boolean,
  ): Promise<CourierActionResult> {
    return request<CourierActionResult>(`/courier/jobs/${encodeURIComponent(id)}/arrived`, {
      method: "POST",
      body: { ...(geo ?? {}), ...(override ? { override: true } : {}) },
    });
  },

  courierPickupJob(id: string): Promise<DeliveryJob> {
    return request<DeliveryJob>(`/courier/jobs/${encodeURIComponent(id)}/pickup`, {
      method: "POST",
    });
  },

  courierDeliverJob(id: string, form: FormData): Promise<CourierActionResult> {
    return formRequest<CourierActionResult>(
      `/courier/jobs/${encodeURIComponent(id)}/deliver`,
      form,
    );
  },

  courierFailJob(id: string, reason: string): Promise<DeliveryJob> {
    return request<DeliveryJob>(`/courier/jobs/${encodeURIComponent(id)}/fail`, {
      method: "POST",
      body: { reason },
    });
  },

  // ── Vacations (Finalizing.MD T3) ────────────────────────────────────────────

  createVacationRequest(
    payload: CreateVacationRequestPayload,
  ): Promise<VacationRequest> {
    return request<VacationRequest>("/vacations", {
      method: "POST",
      body: payload,
    });
  },

  listMyVacationRequests(): Promise<VacationRequest[]> {
    return request<VacationRequest[]>("/vacations/me");
  },

  listVacationRequests(query: {
    status?: VacationRequestStatus;
    userId?: string;
    from?: string;
    to?: string;
  } = {}): Promise<VacationRequest[]> {
    return request<VacationRequest[]>("/vacations", {
      query: {
        ...(query.status ? { status: query.status } : {}),
        ...(query.userId ? { userId: query.userId } : {}),
        ...(query.from ? { from: query.from } : {}),
        ...(query.to ? { to: query.to } : {}),
      },
    });
  },

  listApprovedVacationsForLocation(
    locationId: string,
    range: { from: string; to: string },
  ): Promise<VacationRequest[]> {
    return request<VacationRequest[]>(
      `/vacations/location/${encodeURIComponent(locationId)}/approved`,
      { query: { from: range.from, to: range.to } },
    );
  },

  approveVacationRequest(
    id: string,
    decisionNote?: string,
  ): Promise<VacationRequest> {
    return request<VacationRequest>(
      `/vacations/${encodeURIComponent(id)}/approve`,
      { method: "POST", body: decisionNote ? { decisionNote } : {} },
    );
  },

  rejectVacationRequest(
    id: string,
    decisionNote?: string,
  ): Promise<VacationRequest> {
    return request<VacationRequest>(
      `/vacations/${encodeURIComponent(id)}/reject`,
      { method: "POST", body: decisionNote ? { decisionNote } : {} },
    );
  },

  cancelVacationRequest(id: string): Promise<VacationRequest> {
    return request<VacationRequest>(
      `/vacations/${encodeURIComponent(id)}/cancel`,
      { method: "POST" },
    );
  },

  /** G-51: reverse an action's domain effect; the log row survives. */
  undoAuditAction(
    auditLogId: string,
    reason: string,
  ): Promise<{ undone: string; undoRowId: string }> {
    return request<{ undone: string; undoRowId: string }>(
      `/shop-mode/audit-log/${encodeURIComponent(auditLogId)}/undo`,
      { method: "POST", body: { reason } },
    );
  },

  /** G-45 part 3: unjustified below-floor sale lines (owner/manager). */
  getBelowFloorSales(): Promise<BelowFloorEntry[]> {
    return request<BelowFloorEntry[]>("/sales/below-floor");
  },

  /** G-45 part 3 backstop: a manager/owner justifies from the CRM. */
  justifyBelowFloorLine(
    saleLineId: string,
    reason: string,
  ): Promise<{ id: string }> {
    return request<{ id: string }>(
      `/sales/lines/${encodeURIComponent(saleLineId)}/below-floor-reason`,
      { method: "PATCH", body: { reason } },
    );
  },

  /** G-43: scheduled orders vs stock, two weeks out. OWNER/MANAGER. */
  getForwardDemand(): Promise<ForwardDemandView> {
    return request<ForwardDemandView>("/inventory/forward-demand");
  },

  /** Items at/below reorder threshold with suggested order quantities (T7/T8). */
  getReorderSuggestions(locationId?: string): Promise<ReorderSuggestion[]> {
    return request<ReorderSuggestion[]>("/inventory/reorder-suggestions", {
      query: { ...(locationId ? { locationId } : {}) },
    });
  },

  // ── Analytics (Finalizing.MD T4+T5; G-57: owner = any/all shops, manager =
  //    own shop, decided server-side — `locationId` is only the ASK) ─────────

  getAnalyticsSales(query: {
    locationId?: string;
    from?: string;
    to?: string;
  }): Promise<AnalyticsSalesSummary> {
    return request<AnalyticsSalesSummary>("/analytics/sales", { query });
  },

  getAnalyticsSpend(query: {
    locationId?: string;
    from?: string;
    to?: string;
    categoryId?: string;
  }): Promise<AnalyticsSpendSummary> {
    return request<AnalyticsSpendSummary>("/analytics/spend", { query });
  },

  getAnalyticsWaste(query: {
    locationId?: string;
    from?: string;
    to?: string;
  }): Promise<AnalyticsWasteSummary> {
    return request<AnalyticsWasteSummary>("/analytics/waste", { query });
  },

  /** G-169: the home page's money in one answer (per shop, added once on the server). */
  getAnalyticsHome(query: {
    locationIds?: string[];
    year?: number;
    month?: number;
  }): Promise<AnalyticsHomeSummary> {
    return request<AnalyticsHomeSummary>("/analytics/home", {
      query: {
        locationIds: query.locationIds && query.locationIds.length > 0 ? query.locationIds.join(",") : undefined,
        year: query.year === undefined ? undefined : String(query.year),
        month: query.month === undefined ? undefined : String(query.month),
      },
    });
  },

  getAnalyticsStockValue(query: {
    locationId?: string;
    categoryId?: string;
  }): Promise<AnalyticsStockValue> {
    return request<AnalyticsStockValue>("/analytics/stock-value", { query });
  },

  // ── Supplier honesty extensions (Finalizing.MD T6) ──────────────────────────

  getSupplierRanking(query: { from?: string; to?: string } = {}): Promise<
    SupplierRankingRow[]
  > {
    return request<SupplierRankingRow[]>("/suppliers/ranking", {
      query: {
        ...(query.from ? { from: query.from } : {}),
        ...(query.to ? { to: query.to } : {}),
      },
    });
  },

  getSupplierBatchQuality(
    supplierId: string,
    query: { itemId?: string; from?: string; to?: string } = {},
  ): Promise<SupplierBatchQualityRow[]> {
    return request<SupplierBatchQualityRow[]>(
      `/suppliers/${encodeURIComponent(supplierId)}/batch-quality`,
      {
        query: {
          ...(query.itemId ? { itemId: query.itemId } : {}),
          ...(query.from ? { from: query.from } : {}),
          ...(query.to ? { to: query.to } : {}),
        },
      },
    );
  },

  getItemPriceHistory(
    itemId: string,
    query: { supplierId?: string; from?: string; to?: string } = {},
  ): Promise<ItemPriceHistory> {
    return request<ItemPriceHistory>(
      `/items/${encodeURIComponent(itemId)}/price-history`,
      {
        query: {
          ...(query.supplierId ? { supplierId: query.supplierId } : {}),
          ...(query.from ? { from: query.from } : {}),
          ...(query.to ? { to: query.to } : {}),
        },
      },
    );
  },

  // ── G-32 recurring costs + G-39 one-time expenses ──────────────────────────
  // One contiguous block, appended last, so it merges cleanly.

  /** G-121 S4: "Purchases & IVA paid" for one month — owner only. */
  getPurchasesSummary(
    query: { year?: number; month?: number; locationId?: string } = {},
  ): Promise<PurchasesIvaSummary> {
    return request<PurchasesIvaSummary>("/finances/purchases/summary", {
      query: {
        ...(query.year ? { year: String(query.year) } : {}),
        ...(query.month ? { month: String(query.month) } : {}),
        ...(query.locationId ? { locationId: query.locationId } : {}),
      },
    });
  },

  /** G-171: "IVA on sales" for one month — owner, or a manager for their own shop. */
  getSalesIvaSummary(
    query: { year?: number; month?: number; locationId?: string } = {},
  ): Promise<SalesIvaSummary> {
    return request<SalesIvaSummary>("/finances/iva/sales", {
      query: {
        ...(query.year ? { year: String(query.year) } : {}),
        ...(query.month ? { month: String(query.month) } : {}),
        ...(query.locationId ? { locationId: query.locationId } : {}),
      },
    });
  },

  /** G-171: "Balance with Hacienda" for one month — owner only. */
  getHaciendaBalance(
    query: { year?: number; month?: number; locationId?: string } = {},
  ): Promise<HaciendaBalance> {
    return request<HaciendaBalance>("/finances/iva/balance", {
      query: {
        ...(query.year ? { year: String(query.year) } : {}),
        ...(query.month ? { month: String(query.month) } : {}),
        ...(query.locationId ? { locationId: query.locationId } : {}),
      },
    });
  },

  getOperatingCostsSummary(
    query: { year?: number; month?: number; locationId?: string } = {},
  ): Promise<OperatingCostsSummary> {
    return request<OperatingCostsSummary>("/finances/costs/summary", {
      query: {
        ...(query.year ? { year: String(query.year) } : {}),
        ...(query.month ? { month: String(query.month) } : {}),
        ...(query.locationId ? { locationId: query.locationId } : {}),
      },
    });
  },

  listRecurringCosts(
    query: {
      locationId?: string;
      activeInMonthOf?: string;
      includeEnded?: boolean;
    } = {},
  ): Promise<RecurringCostListResponse> {
    return request<RecurringCostListResponse>("/finances/costs/recurring", {
      query: {
        ...(query.locationId ? { locationId: query.locationId } : {}),
        ...(query.activeInMonthOf
          ? { activeInMonthOf: query.activeInMonthOf }
          : {}),
        ...(query.includeEnded === false ? { includeEnded: "false" } : {}),
      },
    });
  },

  createRecurringCost(
    payload: CreateRecurringCostPayload,
  ): Promise<RecurringCostRecord> {
    return request<RecurringCostRecord>("/finances/costs/recurring", {
      method: "POST",
      body: payload,
    });
  },

  updateRecurringCost(
    id: string,
    payload: UpdateRecurringCostPayload,
  ): Promise<RecurringCostRecord> {
    return request<RecurringCostRecord>(
      `/finances/costs/recurring/${encodeURIComponent(id)}`,
      { method: "PATCH", body: payload },
    );
  },

  deleteRecurringCost(id: string): Promise<{ id: string; deleted: true }> {
    return request<{ id: string; deleted: true }>(
      `/finances/costs/recurring/${encodeURIComponent(id)}`,
      { method: "DELETE" },
    );
  },

  listOneTimeExpenses(
    query: {
      locationId?: string;
      from?: string;
      to?: string;
      category?: OneTimeExpenseCategory;
      /** G-135: only expenses with no invoice yet. */
      withoutInvoice?: boolean;
    } = {},
  ): Promise<OneTimeExpenseListResponse> {
    return request<OneTimeExpenseListResponse>("/finances/costs/one-time", {
      query: {
        ...(query.locationId ? { locationId: query.locationId } : {}),
        ...(query.from ? { from: query.from } : {}),
        ...(query.to ? { to: query.to } : {}),
        ...(query.category ? { category: query.category } : {}),
        ...(query.withoutInvoice ? { withoutInvoice: "true" } : {}),
      },
    });
  },

  /**
   * G-135: always multipart — the receipt photo is required by the server and
   * an invoice PDF may ride along (it can also be attached later).
   */
  createOneTimeExpense(
    payload: CreateOneTimeExpensePayload,
    receipt: File,
    invoice?: File,
  ): Promise<OneTimeExpenseRecord> {
    const fd = new FormData();
    fd.append("locationId", payload.locationId);
    fd.append("incurredOn", payload.incurredOn);
    fd.append("amountEur", String(payload.amountEur));
    fd.append("description", payload.description);
    if (payload.notes) fd.append("notes", payload.notes);
    fd.append("category", payload.category);
    fd.append("receipt", receipt);
    if (invoice) fd.append("invoice", invoice);
    return formRequest<OneTimeExpenseRecord>("/finances/costs/one-time", fd);
  },

  /** G-135: attach (or replace) the invoice PDF of an existing expense. */
  /** OD-177: owner only (admins sign in as owner) — no invoice will come; attaching one later clears it. */
  markOneTimeExpenseNoInvoice(id: string, reason: string): Promise<OneTimeExpenseRecord> {
    return request<OneTimeExpenseRecord>(
      `/finances/costs/one-time/${encodeURIComponent(id)}/no-invoice`,
      { method: "POST", body: { reason } },
    );
  },

  attachOneTimeExpenseInvoice(id: string, invoice: File): Promise<OneTimeExpenseRecord> {
    const fd = new FormData();
    fd.append("invoice", invoice);
    return formRequest<OneTimeExpenseRecord>(
      `/finances/costs/one-time/${encodeURIComponent(id)}/invoice`,
      fd,
    );
  },

  /** The invoice PDF as a blob URL (caller revokes). Null when absent. */
  fetchOneTimeExpenseInvoiceBlobUrl(id: string): Promise<string | null> {
    return fetchBlobUrlOrNull(
      `/finances/costs/one-time/${encodeURIComponent(id)}/invoice`,
    );
  },

  /** Owner only: how many one-off expenses still have no invoice (all shops, all months). */
  getExpensesMissingInvoiceCount(): Promise<{ count: number }> {
    return request<{ count: number }>("/finances/costs/one-time/missing-invoice-count");
  },

  /** Receipt photo as a blob URL (caller revokes). Null when absent. */
  fetchOneTimeExpenseReceiptBlobUrl(id: string): Promise<string | null> {
    return fetchBlobUrlOrNull(
      `/finances/costs/one-time/${encodeURIComponent(id)}/receipt`,
    );
  },

  updateOneTimeExpense(
    id: string,
    payload: UpdateOneTimeExpensePayload,
  ): Promise<OneTimeExpenseRecord> {
    return request<OneTimeExpenseRecord>(
      `/finances/costs/one-time/${encodeURIComponent(id)}`,
      { method: "PATCH", body: payload },
    );
  },

  deleteOneTimeExpense(id: string): Promise<{ id: string; deleted: true }> {
    return request<{ id: string; deleted: true }>(
      `/finances/costs/one-time/${encodeURIComponent(id)}`,
      { method: "DELETE" },
    );
  },
};

// ── Shop-mode helpers ────────────────────────────────────────────────────────

/** Clears the in-memory JWT₁ without triggering the forceLogout callback. */
export function clearAccessToken(): void {
  state.accessToken = null;
  state.loginAtMs = null;
}

// Floor token — in-memory only; never persisted so page refresh forces re-PIN.
export function setFloorToken(token: string): void {
  state.floorToken = token;
}
export function getFloorToken(): string | null {
  return state.floorToken;
}
export function clearFloorToken(): void {
  state.floorToken = null;
}

/**
 * Fetch any floor-scoped binary as an object URL using the floor token (JWT₃).
 * The floor plane holds no JWT₁, so these paths are the SFS-scoped mirrors of
 * the staff image routes. Returns null when unauthenticated or on any error —
 * an image is never worth breaking a floor screen over. Caller owns the
 * returned URL and must URL.revokeObjectURL() it.
 */
async function floorFetchBlobUrl(path: string): Promise<string | null> {
  if (!state.floorToken) return null;
  const response = await fetch(`${BASE_URL}${path}`, {
    headers: { Authorization: `Bearer ${state.floorToken}` },
    credentials: "omit",
  });
  if (!response.ok) return null;
  return URL.createObjectURL(await response.blob());
}

/**
 * G-12 — bouquet photo bytes for the floor tablet. Auth-gated like every other
 * floor image, so it comes back as an object URL rather than a plain src.
 */
export function floorFetchBouquetPhotoBlobUrl(
  buildId: string,
  photoId: string,
): Promise<string | null> {
  return floorFetchBlobUrl(
    `/shop-mode/bouquet/${encodeURIComponent(buildId)}/photos/${encodeURIComponent(photoId)}`,
  );
}

/**
 * G-87 — background removal for a photo taken at the kiosk.
 *
 * The floor-plane twin of `api.removeBackground`. It exists because the staff
 * route sits behind the CRM's JWT and a floor token is rejected there, so the
 * tablet could never have called it. Same contract in both directions: send
 * the file, get a transparent PNG back, and let a non-2xx surface so the
 * caller can offer the original photo instead.
 */
export async function floorRemoveBackground(file: File): Promise<File> {
  if (!state.floorToken) {
    throw buildError(401, { message: "Not signed in on the shop floor" });
  }
  const fd = new FormData();
  fd.append("image", file, file.name);

  const response = await fetch(`${BASE_URL}/shop-mode/images/remove-background`, {
    method: "POST",
    headers: { Authorization: `Bearer ${state.floorToken}` },
    body: fd,
    credentials: "omit",
  });

  if (!response.ok) {
    let body: unknown = null;
    try {
      body = await response.json();
    } catch {
      /* the sidecar's failures are JSON; a binary body here would be a bug */
    }
    throw buildError(response.status, body);
  }

  const blob = await response.blob();
  const baseName = file.name.replace(/\.[^.]+$/, "");
  return new File([blob], `${baseName}.png`, { type: "image/png" });
}

/**
 * G-89 — the floor image fetch, refcounted through the shared item-image
 * cache so a kiosk LIST behaves like the staff one: a single request per
 * item, and object URLs released when the last row unmounts.
 *
 * Deliberately the same cache and the same key as the staff path. The bytes
 * are the same picture; only the door differs, so whichever plane fetched it
 * first serves both.
 */
export function floorFetchItemImageBlobUrlCached(
  itemId: string,
  options?: ItemImageVariant,
): Promise<string | null> {
  const size: ItemImageBlobSize = options?.size === "thumb" ? "thumb" : "full";
  return acquireItemImageBlobUrl(itemId, size, options?.version, () =>
    floorFetchItemImageBlobUrl(itemId, options),
  );
}

export function floorFetchItemImageBlobUrl(
  itemId: string,
  options?: ItemImageVariant,
): Promise<string | null> {
  return floorFetchBlobUrl(`/shop-mode/items/${itemId}/image${itemImageQuery(options)}`);
}

/**
 * G-73 — the photo taken of what was thrown away, for the kiosk. Scoped to
 * this kiosk's own shop server-side, so another shop's movement is a 404.
 */
export function floorFetchWastePhotoBlobUrl(
  movementId: string,
): Promise<string | null> {
  return floorFetchBlobUrl(
    `/shop-mode/inventory/waste/${encodeURIComponent(movementId)}/photo`,
  );
}

export function floorFetchBouquetTemplateImageBlobUrl(
  templateId: string,
): Promise<string | null> {
  return floorFetchBlobUrl(`/shop-mode/bouquet/templates/${templateId}/image`);
}

/** G-156: the shop's receipt logo for the kiosk's print, or null without one. */
export function floorFetchReceiptLogoBlobUrl(): Promise<string | null> {
  return floorFetchBlobUrl(`/shop-mode/receipt-template/logo`);
}

export function floorFetchTaskImageBlobUrl(
  taskId: string,
  slot: "reference" | "completion",
): Promise<string | null> {
  const suffix = slot === "reference" ? "reference-image" : "completion-image";
  return floorFetchBlobUrl(`/shop-mode/tasks/${taskId}/${suffix}`);
}

export function floorFetchOrderReferencePhotoBlobUrl(
  orderId: string,
  photoId: string,
): Promise<string | null> {
  return floorFetchBlobUrl(
    `/shop-mode/orders/${encodeURIComponent(orderId)}/reference-photos/${encodeURIComponent(photoId)}`,
  );
}

// SFS helpers — sessionStorage so it survives page refresh on the tablet.
export function getShopFloorSessionId(): string | null {
  try { return sessionStorage.getItem(SFS_KEY); } catch { return null; }
}
export function setShopFloorSessionId(id: string): boolean {
  try {
    sessionStorage.setItem(SFS_KEY, id);
    return sessionStorage.getItem(SFS_KEY) === id;
  } catch {
    return false;
  }
}
export function clearShopFloorSessionId(): void {
  try { sessionStorage.removeItem(SFS_KEY); } catch { /* */ }
}

/**
 * Register the ShopModeProvider's navigate callback so that when a CRM token
 * refresh fails on a tablet that already has an armed session, the app goes to
 * /app/in-the-shop instead of /login.
 */
export function configureShopMode(options: { navigateToShopMode: () => void }): void {
  state.navigateToShopMode = options.navigateToShopMode;
}

/**
 * One-shot request authenticated by X-Shop-Floor-Session-Id only.
 * Used for: GET /shop-mode/status, POST /shop-mode/pin/verify, DELETE /shop-mode/exit (SFS leg).
 * No JWT₁, no retry — there is no credential to refresh.
 */
export function armedRequest<T>(
  path: string,
  shopFloorSessionId: string,
  opts: Omit<RequestOptions, "skipAuth" | "includeSfs"> = {},
): Promise<T> {
  return rawRequest<T>(path, {
    ...opts,
    skipAuth: true,
    includeSfs: true,
    shopFloorSessionId,
  });
}

/**
 * One-shot request authenticated by JWT₃ (floor token) as Bearer.
 * Used for floor-operation endpoints guarded by FloorJwtGuard.
 * On 401 the caller is responsible for clearing the floor state and re-prompting for PIN.
 */
export async function floorRequest<T>(
  path: string,
  opts: Omit<RequestOptions, "skipAuth" | "withCredentials" | "retry"> = {},
): Promise<T> {
  const url = new URL(`${BASE_URL}${path}`);
  if (opts.query) {
    for (const [key, value] of Object.entries(opts.query)) {
      if (value !== undefined && value !== "") url.searchParams.append(key, value);
    }
  }
  const headers: Record<string, string> = { Accept: "application/json" };
  const isFormData = opts.body instanceof FormData;
  if (opts.body !== undefined && !isFormData) {
    headers["Content-Type"] = "application/json";
  }
  if (state.floorToken) headers["Authorization"] = `Bearer ${state.floorToken}`;
  const requestBody: BodyInit | undefined =
    opts.body === undefined
      ? undefined
      : isFormData
        ? (opts.body as FormData)
        : JSON.stringify(opts.body);

  const response = await fetch(url.toString(), {
    method: opts.method ?? "GET",
    headers,
    body: requestBody,
    credentials: "omit",
  });

  if (response.status === 204) return undefined as T;

  const text = await response.text();
  const parsed = text ? safeJsonParse(text) : null;
  if (!response.ok) {
    noteApiFailure(opts.method ?? "GET", path, response.status);
    throw buildError(response.status, parsed);
  }
  return parsed as T;
}

export type { ApiError };
